import { z } from 'zod';

// src/primitives/brand.ts
var asTenantId = (id) => id;
var asClassId = (id) => id;
var asStudentId = (id) => id;
var asTeacherId = (id) => id;
var asParentId = (id) => id;
var asSpaceId = (id) => id;
var asStoryPointId = (id) => id;
var asModuleId = asStoryPointId;
var asItemId = (id) => id;
var asExamId = (id) => id;
var asSubmissionId = (id) => id;
var asUserId = (id) => id;
var asSessionId = (id) => id;
var asAgentId = (id) => id;
var asAcademicSessionId = (id) => id;
var asNotificationId = (id) => id;
var asQuestionBankItemId = (id) => id;
var asStaffId = (id) => id;
var asScannerId = (id) => id;
var asExamQuestionId = (id) => id;
var asConversationSessionId = (id) => id;
var asConversationMessageId = (id) => id;
var asConversationTurnId = (id) => id;
var asConversationEvidenceId = (id) => id;
var asItemSubmissionId = (id) => id;
var asTenantCode = (id) => id;
var asMembershipId = (id) => id;
var asSectionId = (id) => id;
var asAnswerKeyId = (id) => id;
var asRubricPresetId = (id) => id;
var asTestSessionId = (id) => id;
var asSpaceProgressId = (id) => id;
var asChatSessionId = (id) => id;
var asChatMessageId = (id) => id;
var asSpaceReviewId = (id) => id;
var asContentVersionId = (id) => id;
var asPurchaseId = (id) => id;
var asQuestionSubmissionId = (id) => id;
var asEvaluationSettingsId = (id) => id;
var asDeadLetterEntryId = (id) => id;
var asExamAnalyticsId = (id) => id;
var asInsightId = (id) => id;
var asLlmCallLogId = (id) => id;
var asCostSummaryId = (id) => id;
var asHealthSnapshotId = (id) => id;
var asPlatformActivityLogId = (id) => id;
var asAnnouncementId = (id) => id;
var asAchievementId = (id) => id;
var asStudentAchievementId = (id) => id;
var asStudentLevelId = (id) => id;
var asStudyGoalId = (id) => id;
var asStudySessionId = (id) => id;
var BRAND_TAGS = [
  "TenantId",
  "ClassId",
  "StudentId",
  "TeacherId",
  "ParentId",
  "SpaceId",
  "StoryPointId",
  "ItemId",
  "ExamId",
  "SubmissionId",
  "UserId",
  "SessionId",
  "AgentId",
  "AcademicSessionId",
  "NotificationId",
  "QuestionBankItemId",
  "StaffId",
  "ScannerId",
  "ExamQuestionId"
];
var zBrandedId = (_brand) => z.string().min(1).max(1500).regex(/^[^/]+$/, 'id must not contain "/"').transform((s) => s);
var zTenantId = zBrandedId();
var zClassId = zBrandedId();
var zStudentId = zBrandedId();
var zTeacherId = zBrandedId();
var zParentId = zBrandedId();
var zSpaceId = zBrandedId();
var zStoryPointId = zBrandedId();
var zItemId = zBrandedId();
var zExamId = zBrandedId();
var zSubmissionId = zBrandedId();
var zUserId = zBrandedId();
var zSessionId = zBrandedId();
var zAgentId = zBrandedId();
var zAcademicSessionId = zBrandedId();
var zNotificationId = zBrandedId();
var zQuestionBankItemId = zBrandedId();
var zStaffId = zBrandedId();
var zScannerId = zBrandedId();
var zExamQuestionId = zBrandedId();
var zConversationSessionId = zBrandedId();
var zConversationMessageId = zBrandedId();
var zConversationTurnId = zBrandedId();
var zConversationEvidenceId = zBrandedId();
var zItemSubmissionId = zBrandedId();
var zTenantCode = zBrandedId();
var zMembershipId = zBrandedId();
var zSectionId = zBrandedId();
var zAnswerKeyId = zBrandedId();
var zRubricPresetId = zBrandedId();
var zTestSessionId = zBrandedId();
var zSpaceProgressId = zBrandedId();
var zChatSessionId = zBrandedId();
var zChatMessageId = zBrandedId();
var zSpaceReviewId = zBrandedId();
var zContentVersionId = zBrandedId();
var zPurchaseId = zBrandedId();
var zQuestionSubmissionId = zBrandedId();
var zEvaluationSettingsId = zBrandedId();
var zDeadLetterEntryId = zBrandedId();
var zExamAnalyticsId = zBrandedId();
var zInsightId = zBrandedId();
var zLlmCallLogId = zBrandedId();
var zCostSummaryId = zBrandedId();
var zHealthSnapshotId = zBrandedId();
var zPlatformActivityLogId = zBrandedId();
var zAnnouncementId = zBrandedId();
var zAchievementId = zBrandedId();
var zStudentAchievementId = zBrandedId();
var zStudentLevelId = zBrandedId();
var zStudyGoalId = zBrandedId();
var zStudySessionId = zBrandedId();

// src/primitives/timestamp.ts
var ISO_8601_UTC = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
var isTimestamp = (v) => typeof v === "string" && ISO_8601_UTC.test(v);
var asTimestamp = (iso) => {
  if (!ISO_8601_UTC.test(iso)) {
    throw new RangeError(`not a canonical ISO-8601 UTC timestamp: ${iso}`);
  }
  return iso;
};
var isFirestoreTimestampLike = (v) => "seconds" in v && "nanoseconds" in v;
var isSerializedFirestoreTimestampLike = (v) => "_seconds" in v && "_nanoseconds" in v;
var isMillisTimestampLike = (v) => "toMillis" in v && typeof v.toMillis === "function";
function toDate(input) {
  if (input instanceof Date) {
    if (Number.isNaN(input.getTime())) throw new RangeError("invalid Date");
    return input;
  }
  if (typeof input === "number") {
    if (Number.isNaN(input)) throw new RangeError("invalid epoch-millis (NaN)");
    return new Date(input);
  }
  if (typeof input === "string") {
    const ms = Date.parse(input);
    if (Number.isNaN(ms)) throw new RangeError(`unparseable date string: ${input}`);
    return new Date(ms);
  }
  if (typeof input === "object" && input !== null) {
    if (isFirestoreTimestampLike(input)) {
      return new Date(input.seconds * 1e3 + Math.round(input.nanoseconds / 1e6));
    }
    if (isSerializedFirestoreTimestampLike(input)) {
      return new Date(input._seconds * 1e3 + Math.round(input._nanoseconds / 1e6));
    }
    if (isMillisTimestampLike(input)) {
      const ms = input.toMillis();
      if (Number.isNaN(ms)) throw new RangeError("invalid toMillis() result (NaN)");
      return new Date(ms);
    }
  }
  throw new RangeError("unsupported TimestampInput shape");
}
function toTimestamp(input) {
  if (input == null) return null;
  return toDate(input).toISOString();
}
var toMillis = (t) => Date.parse(t);
var toDateObj = (t) => new Date(t);
var systemClock = () => (/* @__PURE__ */ new Date()).toISOString();
var isoNow = () => (/* @__PURE__ */ new Date()).toISOString();
var zTimestamp = z.string().regex(ISO_8601_UTC).transform((s) => s);
var zTimestampInput = z.preprocess((v) => toTimestamp(v), zTimestamp);

// src/primitives/iso-date.ts
var ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
var isIsoDate = (v) => typeof v === "string" && ISO_DATE.test(v);
var asIsoDate = (s) => {
  if (!ISO_DATE.test(s)) throw new RangeError(`not a YYYY-MM-DD date: ${s}`);
  return s;
};
var zIsoDate = z.string().regex(ISO_DATE).transform((s) => s);

// src/primitives/money.ts
var CURRENCIES = ["INR", "USD"];
var money = (amountMinor, currency) => ({
  amountMinor: Math.round(amountMinor),
  currency
});
var addMoney = (a, b) => {
  if (a.currency !== b.currency) {
    throw new Error(`currency mismatch: ${a.currency} vs ${b.currency}`);
  }
  return { amountMinor: a.amountMinor + b.amountMinor, currency: a.currency };
};
var formatMoney = (m) => {
  const major = m.amountMinor / 100;
  return new Intl.NumberFormat(void 0, { style: "currency", currency: m.currency }).format(
    major
  );
};
var zObject = (shape) => z.object(shape).strict();

// src/primitives/money.zod.ts
var zCurrency = z.enum(CURRENCIES);
var MoneySchema = zObject({
  amountMinor: z.number().int(),
  currency: zCurrency
});
var zMoney = MoneySchema;

// src/primitives/page.ts
var DEFAULT_PAGE_LIMIT = 20;
var MAX_PAGE_LIMIT = 100;
var asCursor = (s) => s;
var zCursor = z.string().transform((s) => s);
var zPageParams = zObject({
  cursor: zCursor.optional(),
  limit: z.number().int().min(1).max(MAX_PAGE_LIMIT).default(DEFAULT_PAGE_LIMIT)
});
var zPage = (item) => zObject({
  items: z.array(item),
  nextCursor: zCursor.nullable(),
  total: z.number().int().optional()
});
var zAuditFields = {
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  createdBy: zUserId,
  updatedBy: zUserId
};
var zSoftDeletable = { archivedAt: zTimestamp.nullable() };
var zTenantScoped = { tenantId: zTenantId };
var withAudit = (shape) => ({ ...shape, ...zAuditFields, ...zSoftDeletable });
var zJsonValue = z.lazy(
  () => z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.array(zJsonValue),
    z.record(z.string(), zJsonValue)
  ])
);
var zJsonObject = z.record(z.string(), zJsonValue);
var zEnum = (values) => z.enum(values);

// src/enums/space.ts
var SPACE_STATUSES = ["draft", "published", "archived"];
var zSpaceStatus = zEnum(SPACE_STATUSES);
var SPACE_TYPES = ["learning", "practice", "assessment", "resource", "hybrid"];
var zSpaceType = zEnum(SPACE_TYPES);
var SPACE_ACCESS_TYPES = ["class_assigned", "tenant_wide", "public_store"];
var zSpaceAccessType = zEnum(SPACE_ACCESS_TYPES);

// src/enums/exam.ts
var EXAM_STATUSES = [
  "draft",
  "question_paper_uploaded",
  "question_paper_extracted",
  "published",
  "grading",
  "results_released",
  "archived"
];
var zExamStatus = zEnum(EXAM_STATUSES);

// src/enums/submission.ts
var SUBMISSION_PIPELINE_STATUSES = [
  "uploaded",
  "scouting",
  "scouting_failed",
  "scouting_complete",
  "grading",
  "grading_partial",
  "grading_failed",
  "grading_complete",
  "finalization_failed",
  "ready_for_review",
  "reviewed",
  "failed",
  "manual_review_needed"
];
var zSubmissionPipelineStatus = zEnum(SUBMISSION_PIPELINE_STATUSES);

// src/enums/question-grading.ts
var QUESTION_GRADING_STATUSES = [
  "pending",
  "processing",
  "graded",
  "needs_review",
  "failed",
  "manual",
  "overridden"
];
var zQuestionGradingStatus = zEnum(QUESTION_GRADING_STATUSES);

// src/enums/test-session.ts
var TEST_SESSION_STATUSES = ["in_progress", "completed", "expired", "abandoned"];
var zTestSessionStatus = zEnum(TEST_SESSION_STATUSES);
var TEST_SESSION_TYPES = ["timed_test", "quiz", "practice"];
var zTestSessionType = zEnum(TEST_SESSION_TYPES);
var QUESTION_STATUSES = [
  "not_visited",
  "not_answered",
  "answered",
  "marked_for_review",
  "answered_and_marked"
];
var zQuestionStatus = zEnum(QUESTION_STATUSES);
var PROGRESS_STATUSES = ["not_started", "in_progress", "completed"];
var zProgressStatus = zEnum(PROGRESS_STATUSES);
var QUESTION_PROGRESS_STATUSES = ["pending", "correct", "incorrect", "partial"];
var zQuestionProgressStatus = zEnum(QUESTION_PROGRESS_STATUSES);
var ROLE_DESCRIPTORS = [
  {
    role: "superAdmin",
    rank: 6,
    idField: "",
    idBrand: z.never(),
    repoKey: "",
    scope: "platform",
    provisionable: false,
    authoring: false
  },
  {
    role: "tenantAdmin",
    rank: 5,
    idField: "",
    idBrand: z.never(),
    repoKey: "",
    scope: "tenant",
    provisionable: false,
    authoring: true
  },
  {
    role: "teacher",
    rank: 3,
    idField: "teacherId",
    idBrand: zTeacherId,
    repoKey: "teachers",
    scope: "tenant",
    provisionable: true,
    authoring: true,
    permissionSet: "teacher"
  },
  {
    role: "student",
    rank: 0,
    idField: "studentId",
    idBrand: zStudentId,
    repoKey: "students",
    scope: "tenant",
    provisionable: true,
    authoring: false
  },
  {
    role: "parent",
    rank: 1,
    idField: "parentId",
    idBrand: zParentId,
    repoKey: "parents",
    scope: "tenant",
    provisionable: true,
    authoring: false
  },
  {
    role: "scanner",
    rank: 2,
    idField: "scannerId",
    idBrand: zScannerId,
    repoKey: "scanners",
    scope: "tenant",
    provisionable: true,
    authoring: false
  },
  {
    role: "staff",
    rank: 4,
    idField: "staffId",
    idBrand: zStaffId,
    repoKey: "staff",
    scope: "tenant",
    provisionable: true,
    authoring: true,
    permissionSet: "staff"
  }
];
var ID_ROLES = ROLE_DESCRIPTORS.filter((d) => d.idField !== "");
var TENANT_ROLES = ROLE_DESCRIPTORS.map((d) => d.role);
var zTenantRole = z.enum(TENANT_ROLES);
var ROLE_RANK = Object.fromEntries(
  ROLE_DESCRIPTORS.map((d) => [d.role, d.rank])
);
var isAuthoringRole = (role) => !!role && (ROLE_DESCRIPTORS.find((d) => d.role === role)?.authoring ?? false);
var repoKeyForRole = (role) => ROLE_DESCRIPTORS.find((d) => d.role === role)?.repoKey || void 0;
var idFieldForRole = (role) => {
  const f = ROLE_DESCRIPTORS.find((d) => d.role === role)?.idField;
  return f ? f : void 0;
};
var roleIdFields = Object.fromEntries(
  ID_ROLES.map((d) => [d.idField, d.idBrand.optional()])
);

// src/enums/tenant.ts
var TENANT_STATUSES = ["active", "suspended", "trial", "expired", "deactivated"];
var zTenantStatus = zEnum(TENANT_STATUSES);
var TENANT_PLANS = ["free", "trial", "basic", "premium", "enterprise"];
var zTenantPlan = zEnum(TENANT_PLANS);
var MEMBERSHIP_STATUSES = ["active", "inactive", "suspended"];
var zMembershipStatus = zEnum(MEMBERSHIP_STATUSES);
var JOIN_SOURCES = [
  "admin_created",
  "bulk_import",
  "invite_code",
  "self_register",
  "migration",
  "tenant_code"
];
var zJoinSource = zEnum(JOIN_SOURCES);
var USER_STATUSES = ["active", "suspended", "deleted"];
var zUserStatus = zEnum(USER_STATUSES);
var ENTITY_STATUSES = ["active", "archived"];
var zEntityStatus = zEnum(ENTITY_STATUSES);
var CONSUMER_PLANS = ["free", "pro", "premium"];
var zConsumerPlan = zEnum(CONSUMER_PLANS);
var ConversationPublicLearningObjectiveSchema = zObject({
  id: z.string(),
  label: z.string()
});
var ConversationCompletionPolicySchema = zObject({
  minLearnerTurns: z.number().int().positive(),
  maxLearnerTurns: z.number().int().positive().max(12),
  allowEarlyFinish: z.boolean(),
  hardLimitAction: z.literal("auto_finalize")
}).superRefine((policy, ctx) => {
  if (policy.minLearnerTurns > policy.maxLearnerTurns) {
    ctx.addIssue({
      code: "custom",
      message: "minLearnerTurns must be less than or equal to maxLearnerTurns",
      path: ["minLearnerTurns"]
    });
  }
});
var AgentAssessmentQuestionPromptSchema = zObject({
  questionType: z.literal("chat_agent_question"),
  scenario: z.string(),
  publicLearningObjectives: z.array(ConversationPublicLearningObjectiveSchema),
  conversationStarters: z.array(z.string()).optional(),
  interviewerAgentId: zAgentId,
  completionPolicy: ConversationCompletionPolicySchema
});
var AgentAssessmentPrivateObjectiveSchema = zObject({
  id: z.string(),
  rubricDimensionId: z.string(),
  description: z.string(),
  evidenceRequirement: z.string().optional()
});
var AgentAssessmentAnswerKeyDataSchema = zObject({
  questionType: z.literal("chat_agent_question"),
  modelAnswer: z.string().optional(),
  evaluationGuidance: z.string().optional(),
  privateEvaluationObjectives: z.array(AgentAssessmentPrivateObjectiveSchema)
});
var AgentAssessmentLearnerAnswerSchema = zObject({
  questionType: z.literal("chat_agent_question"),
  sessionId: zConversationSessionId,
  submissionId: zItemSubmissionId.optional()
});

// src/entities/content/question-types/registry.ts
var McqOptionSchema = zObject({
  id: z.string(),
  text: z.string(),
  imageUrl: z.string().optional(),
  explanation: z.string().optional(),
  // ⚷ stripped into AnswerKey server-side for non-authoring reads.
  isCorrect: z.boolean().optional()
});
var BlankSlotSchema = zObject({
  id: z.string(),
  correctAnswer: z.string().optional(),
  acceptableAnswers: z.array(z.string()).optional()
});
var MatchPairPromptSchema = zObject({ left: z.string(), right: z.string().optional() });
var MatchPairAnswerSchema = zObject({ left: z.string(), right: z.string() });
var GroupOptionItemSchema = zObject({
  id: z.string(),
  text: z.string(),
  group: z.string().optional()
});
var McqPrompt = zObject({
  questionType: z.literal("mcq"),
  options: z.array(McqOptionSchema),
  shuffleOptions: z.boolean().optional()
});
var McaqPrompt = zObject({
  questionType: z.literal("mcaq"),
  options: z.array(McqOptionSchema),
  shuffleOptions: z.boolean().optional(),
  minSelections: z.number().int().optional(),
  maxSelections: z.number().int().optional()
});
var TrueFalsePrompt = zObject({
  questionType: z.literal("true-false"),
  correctAnswer: z.boolean().optional(),
  explanation: z.string().optional()
});
var NumericalPrompt = zObject({
  questionType: z.literal("numerical"),
  correctAnswer: z.number().optional(),
  tolerance: z.number().optional(),
  unit: z.string().optional(),
  decimalPlaces: z.number().int().nonnegative().optional()
});
var TextPrompt = zObject({
  questionType: z.literal("text"),
  maxLength: z.number().int().optional(),
  modelAnswer: z.string().optional(),
  acceptableAnswers: z.array(z.string()).optional(),
  caseSensitive: z.boolean().optional()
});
var ParagraphPrompt = zObject({
  questionType: z.literal("paragraph"),
  minWords: z.number().int().optional(),
  maxWords: z.number().int().optional(),
  modelAnswer: z.string().optional(),
  evaluationGuidance: z.string().optional()
});
var CodePrompt = zObject({
  questionType: z.literal("code"),
  language: z.string().optional(),
  starterCode: z.string().optional(),
  modelAnswer: z.string().optional(),
  testCases: z.array(z.object({ input: z.string(), output: z.string() }).strict()).optional()
});
var FillBlanksPrompt = zObject({
  questionType: z.literal("fill-blanks"),
  template: z.string(),
  blanks: z.array(BlankSlotSchema)
});
var FillBlanksDdPrompt = zObject({
  questionType: z.literal("fill-blanks-dd"),
  template: z.string(),
  blanks: z.array(BlankSlotSchema),
  optionPool: z.array(z.string())
});
var MatchingPrompt = zObject({
  questionType: z.literal("matching"),
  pairs: z.array(MatchPairPromptSchema),
  shufflePairs: z.boolean().optional(),
  // Learner-facing pool of right-side match targets, server-projected on LEARNER
  // reads (absent in authoring). Decoupled from `pairs` order so the correct
  // positional left→right mapping is NOT leaked while the option set stays
  // visible (a matching question is unanswerable without its right column).
  options: z.array(z.string()).optional()
});
var JumbledPrompt = zObject({
  questionType: z.literal("jumbled"),
  tokens: z.array(z.string()),
  correctOrder: z.array(z.number().int()).optional()
});
var AudioPrompt = zObject({
  questionType: z.literal("audio"),
  promptAudioUrl: z.string().optional(),
  maxDurationSeconds: z.number().int().optional(),
  language: z.string().optional(),
  modelAnswer: z.string().optional(),
  evaluationGuidance: z.string().optional()
});
var ImageEvaluationPrompt = zObject({
  questionType: z.literal("image_evaluation"),
  referenceImageUrls: z.array(z.string()).optional(),
  instructions: z.string().optional(),
  maxImages: z.number().int().positive().optional(),
  modelAnswer: z.string().optional(),
  evaluationGuidance: z.string().optional()
});
var GroupOptionsPrompt = zObject({
  questionType: z.literal("group-options"),
  groups: z.array(z.string()),
  items: z.array(GroupOptionItemSchema)
});
var ChatAgentQuestionPrompt = AgentAssessmentQuestionPromptSchema;
var McqAnswer = zObject({
  questionType: z.literal("mcq"),
  correctOptionIds: z.array(z.string())
});
var McaqAnswer = zObject({
  questionType: z.literal("mcaq"),
  correctOptionIds: z.array(z.string())
});
var TrueFalseAnswer = zObject({
  questionType: z.literal("true-false"),
  correctAnswer: z.boolean()
});
var NumericalAnswer = zObject({
  questionType: z.literal("numerical"),
  value: z.number(),
  tolerance: z.number().optional(),
  unit: z.string().optional()
});
var TextAnswer = zObject({
  questionType: z.literal("text"),
  modelAnswer: z.string().optional(),
  acceptableAnswers: z.array(z.string()).optional()
});
var ParagraphAnswer = zObject({
  questionType: z.literal("paragraph"),
  modelAnswer: z.string().optional()
});
var CodeAnswer = zObject({
  questionType: z.literal("code"),
  modelAnswer: z.string().optional(),
  testCases: z.array(z.object({ input: z.string(), output: z.string() }).strict()).optional()
});
var FillBlanksAnswer = zObject({
  questionType: z.literal("fill-blanks"),
  blanks: z.array(BlankSlotSchema)
});
var FillBlanksDdAnswer = zObject({
  questionType: z.literal("fill-blanks-dd"),
  blanks: z.array(BlankSlotSchema)
});
var MatchingAnswer = zObject({
  questionType: z.literal("matching"),
  pairs: z.array(MatchPairAnswerSchema)
});
var JumbledAnswer = zObject({
  questionType: z.literal("jumbled"),
  correctOrder: z.array(z.number().int())
});
var AudioAnswer = zObject({
  questionType: z.literal("audio"),
  modelAnswer: z.string().optional()
});
var ImageEvaluationAnswer = zObject({
  questionType: z.literal("image_evaluation"),
  modelAnswer: z.string().optional()
});
var GroupOptionsAnswer = zObject({
  questionType: z.literal("group-options"),
  assignments: z.array(zObject({ itemId: z.string(), group: z.string() }))
});
var ChatAgentQuestionAnswer = AgentAssessmentAnswerKeyDataSchema;
var McqLearner = zObject({
  questionType: z.literal("mcq"),
  selectedOptionIds: z.array(z.string())
});
var McaqLearner = zObject({
  questionType: z.literal("mcaq"),
  selectedOptionIds: z.array(z.string())
});
var TrueFalseLearner = zObject({ questionType: z.literal("true-false"), answer: z.boolean() });
var NumericalLearner = zObject({ questionType: z.literal("numerical"), value: z.number() });
var TextLearner = zObject({ questionType: z.literal("text"), text: z.string() });
var ParagraphLearner = zObject({ questionType: z.literal("paragraph"), text: z.string() });
var CodeLearner = zObject({
  questionType: z.literal("code"),
  code: z.string(),
  language: z.string().optional()
});
var FillBlanksLearner = zObject({
  questionType: z.literal("fill-blanks"),
  answers: z.array(zObject({ id: z.string(), value: z.string() }))
});
var FillBlanksDdLearner = zObject({
  questionType: z.literal("fill-blanks-dd"),
  answers: z.array(zObject({ id: z.string(), value: z.string() }))
});
var MatchingLearner = zObject({
  questionType: z.literal("matching"),
  matches: z.array(MatchPairAnswerSchema)
});
var JumbledLearner = zObject({
  questionType: z.literal("jumbled"),
  order: z.array(z.number().int())
});
var AudioLearner = zObject({ questionType: z.literal("audio"), audioUrl: z.string() });
var ImageEvaluationLearner = zObject({
  questionType: z.literal("image_evaluation"),
  imageUrls: z.array(z.string())
});
var GroupOptionsLearner = zObject({
  questionType: z.literal("group-options"),
  assignments: z.array(zObject({ itemId: z.string(), group: z.string() }))
});
var ChatAgentQuestionLearner = AgentAssessmentLearnerAnswerSchema;
var QUESTION_TYPE_REGISTRY = {
  mcq: {
    prompt: McqPrompt,
    answer: McqAnswer,
    learnerAnswer: McqLearner,
    evaluation: "auto",
    label: "Multiple choice",
    sample: () => ({ questionType: "mcq", options: [{ id: "a", text: "A" }] })
  },
  mcaq: {
    prompt: McaqPrompt,
    answer: McaqAnswer,
    learnerAnswer: McaqLearner,
    evaluation: "auto",
    label: "Multiple correct answers",
    sample: () => ({ questionType: "mcaq", options: [{ id: "a", text: "A" }] })
  },
  "true-false": {
    prompt: TrueFalsePrompt,
    answer: TrueFalseAnswer,
    learnerAnswer: TrueFalseLearner,
    evaluation: "auto",
    label: "True / false",
    sample: () => ({ questionType: "true-false" })
  },
  numerical: {
    prompt: NumericalPrompt,
    answer: NumericalAnswer,
    learnerAnswer: NumericalLearner,
    evaluation: "auto",
    label: "Numerical",
    sample: () => ({ questionType: "numerical" })
  },
  text: {
    prompt: TextPrompt,
    answer: TextAnswer,
    learnerAnswer: TextLearner,
    evaluation: "ai",
    label: "Short answer",
    sample: () => ({ questionType: "text" })
  },
  paragraph: {
    prompt: ParagraphPrompt,
    answer: ParagraphAnswer,
    learnerAnswer: ParagraphLearner,
    evaluation: "ai",
    label: "Long answer",
    sample: () => ({ questionType: "paragraph" })
  },
  code: {
    prompt: CodePrompt,
    answer: CodeAnswer,
    learnerAnswer: CodeLearner,
    evaluation: "ai",
    label: "Code",
    sample: () => ({ questionType: "code" })
  },
  "fill-blanks": {
    prompt: FillBlanksPrompt,
    answer: FillBlanksAnswer,
    learnerAnswer: FillBlanksLearner,
    evaluation: "auto",
    label: "Fill in the blanks",
    sample: () => ({ questionType: "fill-blanks", template: "__", blanks: [{ id: "b1" }] })
  },
  "fill-blanks-dd": {
    prompt: FillBlanksDdPrompt,
    answer: FillBlanksDdAnswer,
    learnerAnswer: FillBlanksDdLearner,
    evaluation: "auto",
    label: "Fill in the blanks (drag & drop)",
    sample: () => ({
      questionType: "fill-blanks-dd",
      template: "__",
      blanks: [{ id: "b1" }],
      optionPool: ["x"]
    })
  },
  matching: {
    prompt: MatchingPrompt,
    answer: MatchingAnswer,
    learnerAnswer: MatchingLearner,
    evaluation: "auto",
    label: "Matching",
    sample: () => ({ questionType: "matching", pairs: [{ left: "l", right: "r" }] })
  },
  jumbled: {
    prompt: JumbledPrompt,
    answer: JumbledAnswer,
    learnerAnswer: JumbledLearner,
    evaluation: "auto",
    label: "Reorder",
    sample: () => ({ questionType: "jumbled", tokens: ["a", "b"] })
  },
  audio: {
    prompt: AudioPrompt,
    answer: AudioAnswer,
    learnerAnswer: AudioLearner,
    evaluation: "ai",
    label: "Audio response",
    sample: () => ({ questionType: "audio" })
  },
  image_evaluation: {
    prompt: ImageEvaluationPrompt,
    answer: ImageEvaluationAnswer,
    learnerAnswer: ImageEvaluationLearner,
    evaluation: "ai",
    label: "Image evaluation",
    sample: () => ({ questionType: "image_evaluation" })
  },
  "group-options": {
    prompt: GroupOptionsPrompt,
    answer: GroupOptionsAnswer,
    learnerAnswer: GroupOptionsLearner,
    evaluation: "auto",
    label: "Group options",
    sample: () => ({
      questionType: "group-options",
      groups: ["g"],
      items: [{ id: "i", text: "I" }]
    })
  },
  chat_agent_question: {
    prompt: ChatAgentQuestionPrompt,
    answer: ChatAgentQuestionAnswer,
    learnerAnswer: ChatAgentQuestionLearner,
    evaluation: "ai",
    label: "Chat-agent question",
    sample: () => ({
      questionType: "chat_agent_question",
      scenario: "Discuss the trade-offs in this approach.",
      publicLearningObjectives: [{ id: "objective_1", label: "Explain the trade-off" }],
      interviewerAgentId: "agent_interviewer",
      completionPolicy: {
        minLearnerTurns: 1,
        maxLearnerTurns: 4,
        allowEarlyFinish: true,
        hardLimitAction: "auto_finalize"
      }
    })
  }
};
var QUESTION_TYPES = Object.keys(QUESTION_TYPE_REGISTRY);
var zQuestionType = z.enum(QUESTION_TYPES);
var promptMembers = QUESTION_TYPES.map((t) => QUESTION_TYPE_REGISTRY[t].prompt);
var QuestionTypeDataSchema = z.discriminatedUnion("questionType", promptMembers);
var AUTO_EVALUATABLE_TYPES = QUESTION_TYPES.filter(
  (t) => QUESTION_TYPE_REGISTRY[t].evaluation === "auto"
);
var AI_EVALUATABLE_TYPES = QUESTION_TYPES.filter(
  (t) => QUESTION_TYPE_REGISTRY[t].evaluation === "ai"
);
var minimalQuestionData = (qt) => QUESTION_TYPE_REGISTRY[qt].sample();

// src/enums/content.ts
var ITEM_TYPES = [
  "question",
  "material",
  "interactive",
  "assessment",
  "discussion",
  "project",
  "checkpoint"
];
var zItemType = zEnum(ITEM_TYPES);
var ITEM_KINDS = ITEM_TYPES;
var MATERIAL_TYPES = [
  "text",
  "video",
  "pdf",
  "link",
  "interactive",
  "story",
  "rich"
];
var zMaterialType = zEnum(MATERIAL_TYPES);
var INTERACTIVE_TYPES = ["simulation", "demo", "tool", "game"];
var zInteractiveType = zEnum(INTERACTIVE_TYPES);
var ITEM_ASSESSMENT_TYPES = ["quiz", "exam", "project", "peer_review"];
var zItemAssessmentType = zEnum(ITEM_ASSESSMENT_TYPES);
var STORY_POINT_TYPES = ["standard", "timed_test", "quiz", "practice"];
var zStoryPointType = zEnum(STORY_POINT_TYPES);
var RICH_BLOCK_TYPES = [
  "heading",
  "paragraph",
  "image",
  "video",
  "audio",
  "code",
  "quote",
  "list",
  "divider"
];
var zRichBlockType = zEnum(RICH_BLOCK_TYPES);
var DISCUSSION_THREAD_TYPES = ["open", "guided"];
var zDiscussionThreadType = zEnum(DISCUSSION_THREAD_TYPES);
var ITEM_ATTACHMENT_TYPES = ["image", "pdf", "audio"];
var zItemAttachmentType = zEnum(ITEM_ATTACHMENT_TYPES);
var RUBRIC_SCORING_MODES = [
  "criteria_based",
  "dimension_based",
  "holistic",
  "hybrid"
];
var zRubricScoringMode = zEnum(RUBRIC_SCORING_MODES);
var DIMENSION_PRIORITIES = ["HIGH", "MEDIUM", "LOW"];
var zDimensionPriority = zEnum(DIMENSION_PRIORITIES);
var FEEDBACK_SEVERITIES = ["critical", "major", "minor"];
var zFeedbackSeverity = zEnum(FEEDBACK_SEVERITIES);
var MISTAKE_CLASSIFICATIONS = [
  "Conceptual",
  "Silly Error",
  "Knowledge Gap",
  "None"
];
var zMistakeClassification = zEnum(MISTAKE_CLASSIFICATIONS);
var RUBRIC_PRESET_CATEGORIES = [
  "general",
  "coding",
  "essay",
  "math",
  "science",
  "language",
  "custom"
];
var zRubricPresetCategory = zEnum(RUBRIC_PRESET_CATEGORIES);
var AGENT_TYPES = ["tutor", "interviewer", "evaluator"];
var zAgentType = zEnum(AGENT_TYPES);
var CHAT_MESSAGE_ROLES = ["user", "assistant", "system"];
var zChatMessageRole = zEnum(CHAT_MESSAGE_ROLES);
var CONTENT_VERSION_ENTITY_TYPES = ["space", "storyPoint", "item"];
var zContentVersionEntityType = zEnum(CONTENT_VERSION_ENTITY_TYPES);
var CONTENT_CHANGE_TYPES = ["created", "updated", "published", "archived"];
var zContentChangeType = zEnum(CONTENT_CHANGE_TYPES);
var PURCHASE_STATUSES = ["completed", "failed", "pending"];
var zPurchaseStatus = zEnum(PURCHASE_STATUSES);

// src/enums/grading.ts
var GRADE_LETTERS = ["A+", "A", "B+", "B", "C+", "C", "D", "F"];
var zGradeLetter = zEnum(GRADE_LETTERS);
var GRADE_THRESHOLDS = [
  { letter: "A+", min: 90 },
  { letter: "A", min: 80 },
  { letter: "B+", min: 70 },
  { letter: "B", min: 60 },
  { letter: "C+", min: 50 },
  { letter: "C", min: 40 },
  { letter: "D", min: 33 },
  { letter: "F", min: 0 }
];
function gradeForPercentage(pct) {
  const p = Number.isFinite(pct) ? Math.max(0, pct) : 0;
  return (GRADE_THRESHOLDS.find((t) => p >= t.min) ?? GRADE_THRESHOLDS[GRADE_THRESHOLDS.length - 1]).letter;
}
var BLOOMS_LEVELS = [
  "remember",
  "understand",
  "apply",
  "analyze",
  "evaluate",
  "create"
];
var zBloomsLevel = zEnum(BLOOMS_LEVELS);
var DIFFICULTIES = ["easy", "medium", "hard"];
var zDifficulty = zEnum(DIFFICULTIES);
var AUTHORING_DIFFICULTIES = ["easy", "medium", "hard", "expert"];
var zAuthoringDifficulty = zEnum(AUTHORING_DIFFICULTIES);

// src/enums/permissions.ts
var TEACHER_PERMISSION_KEYS = [
  "canManageSpaces",
  "canManageStudents",
  "canManageClasses",
  "canCreateExams",
  "canGradeExams",
  "canViewAnalytics",
  "canManageContent",
  "canReleaseResults"
];
var zTeacherPermissionKey = zEnum(TEACHER_PERMISSION_KEYS);
var STAFF_PERMISSION_KEYS = [
  "canManageUsers",
  "canManageClasses",
  "canImportData",
  "canExportData",
  "canViewAnalytics",
  "canManageAnnouncements"
];
var zStaffPermissionKey = zEnum(STAFF_PERMISSION_KEYS);
var MAX_CLAIM_CLASS_IDS = 15;

// src/enums/misc.ts
var AUTH_PROVIDERS = ["email", "phone", "google", "apple"];
var zAuthProvider = zEnum(AUTH_PROVIDERS);
var UPLOAD_SOURCES = ["web", "scanner", "rn"];
var zUploadSource = zEnum(UPLOAD_SOURCES);
var ANNOUNCEMENT_SCOPES = ["platform", "tenant"];
var zAnnouncementScope = zEnum(ANNOUNCEMENT_SCOPES);
var ANNOUNCEMENT_STATUSES = ["draft", "published", "archived"];
var zAnnouncementStatus = zEnum(ANNOUNCEMENT_STATUSES);

// src/enums/notification.ts
var NOTIFICATION_TYPES = [
  "exam_results_released",
  "new_exam_assigned",
  "new_space_assigned",
  "submission_graded",
  "grading_complete",
  "student_at_risk",
  "deadline_reminder",
  "space_published",
  "bulk_import_complete",
  "ai_budget_alert",
  "system_announcement"
];
var zNotificationType = zEnum(NOTIFICATION_TYPES);
var NOTIFICATION_ENTITY_TYPES = [
  "exam",
  "space",
  "submission",
  "student",
  "class"
];
var zNotificationEntityType = zEnum(NOTIFICATION_ENTITY_TYPES);
var NOTIFICATION_RECIPIENT_ROLES = [
  "teacher",
  "student",
  "parent",
  "tenantAdmin"
];
var zNotificationRecipientRole = zEnum(NOTIFICATION_RECIPIENT_ROLES);

// src/enums/analytics.ts
var AT_RISK_REASONS = [
  "low_exam_score",
  "no_recent_activity",
  "low_space_completion",
  "declining_performance",
  "zero_streak"
];
var zAtRiskReason = zEnum(AT_RISK_REASONS);
var INSIGHT_TYPES = [
  "weak_topic_recommendation",
  "exam_preparation",
  "streak_encouragement",
  "improvement_celebration",
  "at_risk_intervention",
  "cross_system_correlation"
];
var zInsightType = zEnum(INSIGHT_TYPES);
var INSIGHT_PRIORITIES = ["high", "medium", "low"];
var zInsightPriority = zEnum(INSIGHT_PRIORITIES);
var INSIGHT_ACTION_TYPES = [
  "practice_space",
  "review_exam",
  "seek_help",
  "celebrate"
];
var zInsightActionType = zEnum(INSIGHT_ACTION_TYPES);
var LLM_CALL_STATUSES = ["success", "error"];
var zLlmCallStatus = zEnum(LLM_CALL_STATUSES);
var DAY_HEALTH_STATUSES = ["healthy", "degraded", "down"];
var zDayHealthStatus = zEnum(DAY_HEALTH_STATUSES);
var PLATFORM_ACTIVITY_ACTIONS = [
  "tenant_created",
  "tenant_updated",
  "tenant_deactivated",
  "tenant_reactivated",
  "user_created",
  "users_bulk_imported"
];
var zPlatformActivityAction = zEnum(PLATFORM_ACTIVITY_ACTIONS);
var COST_SUMMARY_GRANULARITIES = ["daily", "monthly"];
var zCostSummaryGranularity = zEnum(COST_SUMMARY_GRANULARITIES);

// src/enums/gamification.ts
var ACHIEVEMENT_CATEGORIES = [
  "learning",
  "consistency",
  "excellence",
  "exploration",
  "social",
  "milestone"
];
var zAchievementCategory = zEnum(ACHIEVEMENT_CATEGORIES);
var ACHIEVEMENT_RARITIES = ["common", "uncommon", "rare", "epic", "legendary"];
var zAchievementRarity = zEnum(ACHIEVEMENT_RARITIES);
var ACHIEVEMENT_TIERS = ["bronze", "silver", "gold", "platinum", "diamond"];
var zAchievementTier = zEnum(ACHIEVEMENT_TIERS);
var ACHIEVEMENT_CRITERIA_TYPES = [
  "spaces_completed",
  "story_points_completed",
  "exams_passed",
  "perfect_scores",
  "streak_days",
  "total_points",
  "items_completed",
  "chat_sessions",
  "leaderboard_top3",
  "login_days"
];
var zAchievementCriteriaType = zEnum(ACHIEVEMENT_CRITERIA_TYPES);
var STUDY_GOAL_TARGET_TYPES = [
  "spaces",
  "story_points",
  "items",
  "exams",
  "minutes"
];
var zStudyGoalTargetType = zEnum(STUDY_GOAL_TARGET_TYPES);
var LEADERBOARD_SCOPES = ["tenant", "space", "storyPoint"];
var zLeaderboardScope = zEnum(LEADERBOARD_SCOPES);

// src/enums/keys.ts
var KEY_PROVIDERS = ["google"];
var zKeyProvider = zEnum(KEY_PROVIDERS);
var KEY_STATUSES = ["active", "invalid", "revoked"];
var zKeyStatus = zEnum(KEY_STATUSES);
var CREDENTIAL_OWNERS = ["user", "tenant", "platform"];
var zCredentialOwner = zEnum(CREDENTIAL_OWNERS);
var RubricCriterionLevelSchema = zObject({
  label: z.string(),
  description: z.string().optional(),
  score: z.number()
});
var RubricCriterionSchema = zObject({
  id: z.string().optional(),
  name: z.string(),
  description: z.string().optional(),
  maxScore: z.number(),
  weight: z.number().optional(),
  levels: z.array(RubricCriterionLevelSchema).optional()
});
var EvaluationDimensionSchema = zObject({
  id: z.string(),
  name: z.string(),
  description: z.string().optional(),
  priority: zDimensionPriority,
  weight: z.number().optional(),
  scoringScale: z.number().optional(),
  // ⚷ authoring-only — leaks how to score.
  promptGuidance: z.string().optional()
});
var UnifiedRubricSchema = zObject({
  scoringMode: zRubricScoringMode,
  criteria: z.array(RubricCriterionSchema).optional(),
  dimensions: z.array(EvaluationDimensionSchema).optional(),
  holisticGuidance: z.string().optional(),
  holisticMaxScore: z.number().optional(),
  passingPercentage: z.number().optional(),
  showModelAnswer: z.boolean().optional(),
  // ⚷ authoring-only.
  modelAnswer: z.string().optional(),
  evaluatorGuidance: z.string().optional()
});
function coerceUnifiedRubric(raw, fallbackMaxScore = 10) {
  const r = raw && typeof raw === "object" ? raw : {};
  const parsed = UnifiedRubricSchema.safeParse(r);
  if (parsed.success) return parsed.data;
  const dimsIn = Array.isArray(r.dimensions) ? r.dimensions : [];
  const totalPoints = typeof r.totalPoints === "number" ? r.totalPoints : void 0;
  const passingScore = typeof r.passingScore === "number" ? r.passingScore : void 0;
  const passingPercentage = typeof r.passingPercentage === "number" ? r.passingPercentage : passingScore != null && totalPoints ? Math.round(passingScore / totalPoints * 100) : void 0;
  const modelAnswer = typeof r.modelAnswer === "string" ? r.modelAnswer : void 0;
  const evaluatorGuidance = typeof r.evaluatorGuidance === "string" ? r.evaluatorGuidance : void 0;
  if (dimsIn.length === 0) {
    return UnifiedRubricSchema.parse({
      scoringMode: "holistic",
      holisticMaxScore: totalPoints ?? fallbackMaxScore,
      holisticGuidance: evaluatorGuidance,
      passingPercentage,
      modelAnswer,
      evaluatorGuidance
    });
  }
  return UnifiedRubricSchema.parse({
    scoringMode: "dimension_based",
    dimensions: dimsIn.map((d, i) => ({
      id: String(d.id ?? d.key ?? `dim_${i}`),
      name: String(d.name ?? d.label ?? `Dimension ${i + 1}`),
      description: typeof d.description === "string" ? d.description : void 0,
      priority: d.priority === "HIGH" || d.priority === "LOW" || d.priority === "MEDIUM" ? d.priority : "MEDIUM",
      weight: typeof d.weight === "number" ? d.weight : void 0,
      scoringScale: typeof d.scoringScale === "number" ? d.scoringScale : void 0,
      promptGuidance: typeof d.promptGuidance === "string" ? d.promptGuidance : void 0
    })),
    passingPercentage,
    modelAnswer,
    evaluatorGuidance
  });
}

// src/entities/autograde/evaluation-settings.ts
var EvaluationDisplaySettingsSchema = zObject({
  showStrengths: z.boolean(),
  showKeyTakeaway: z.boolean(),
  prioritizeByImportance: z.boolean()
});
var EvaluationConfidenceConfigSchema = zObject({
  confidenceThreshold: z.number().default(0.7),
  autoApproveThreshold: z.number().default(0.9),
  requireReviewForPartialCredit: z.boolean()
});
var UsageQuotaConfigSchema = zObject({
  monthlyBudgetUsd: z.number(),
  dailyCallLimit: z.number().int(),
  warningThresholdPercent: z.number().default(80)
});
var EvaluationSettingsSchema = zObject({
  id: zEvaluationSettingsId,
  name: z.string(),
  description: z.string().optional(),
  isDefault: z.boolean(),
  isPublic: z.boolean().optional(),
  enabledDimensions: z.array(EvaluationDimensionSchema),
  displaySettings: EvaluationDisplaySettingsSchema,
  confidenceConfig: EvaluationConfidenceConfigSchema.optional(),
  usageQuota: UsageQuotaConfigSchema.optional(),
  createdBy: zUserId.optional(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp
});
var GRADING_PIPELINE_STEPS = ["scouting", "grading"];
var DEAD_LETTER_RESOLUTION_METHODS = [
  "retry_success",
  "manual_grade",
  "dismissed"
];
var GradingDeadLetterEntrySchema = zObject({
  id: zDeadLetterEntryId,
  submissionId: zSubmissionId,
  questionSubmissionId: zQuestionSubmissionId.optional(),
  pipelineStep: z.enum(GRADING_PIPELINE_STEPS),
  error: z.string(),
  errorStack: z.string().optional(),
  attempts: z.number().int(),
  lastAttemptAt: zTimestamp,
  resolvedAt: zTimestamp.nullable(),
  resolvedBy: zUserId.optional(),
  resolutionMethod: z.enum(DEAD_LETTER_RESOLUTION_METHODS).optional(),
  createdAt: zTimestamp
});

// src/enums/legacy.ts
var LEGACY_EXAM_STATUSES = ["completed"];
var normalizeExamStatus = (value) => value === "completed" ? "grading" : value;
var zLegacyExamStatusRead = z.enum([...EXAM_STATUSES, ...LEGACY_EXAM_STATUSES]).transform(normalizeExamStatus);
var LEGACY_SUBMISSION_PIPELINE_STATUSES = ["ocr_processing", "ocr_failed"];
var SUBMISSION_PIPELINE_STATUS_MAP = {
  ocr_processing: "scouting",
  ocr_failed: "scouting_failed"
};
var normalizeSubmissionPipelineStatus = (value) => value in SUBMISSION_PIPELINE_STATUS_MAP ? SUBMISSION_PIPELINE_STATUS_MAP[value] : value;
var zLegacySubmissionPipelineStatusRead = z.enum([...SUBMISSION_PIPELINE_STATUSES, ...LEGACY_SUBMISSION_PIPELINE_STATUSES]).transform(normalizeSubmissionPipelineStatus);
var LEGACY_GRADING_PIPELINE_STEPS = ["ocr"];
var normalizeGradingPipelineStep = (value) => value === "ocr" ? "scouting" : value;
var zLegacyGradingPipelineStepRead = z.enum([...GRADING_PIPELINE_STEPS, ...LEGACY_GRADING_PIPELINE_STEPS]).transform(normalizeGradingPipelineStep);
var LEGACY_UPLOAD_SOURCES = ["gcs"];
var normalizeUploadSource = (value) => value === "gcs" ? "scanner" : value;
var zLegacyUploadSourceRead = z.enum([...UPLOAD_SOURCES, ...LEGACY_UPLOAD_SOURCES]).transform(normalizeUploadSource);
var LEGACY_STORY_POINT_TYPES = ["test"];
var normalizeStoryPointType = (value) => value === "test" ? "timed_test" : value;
var zLegacyStoryPointTypeRead = z.enum([...STORY_POINT_TYPES, ...LEGACY_STORY_POINT_TYPES]).transform(normalizeStoryPointType);
var LEGACY_TEST_SESSION_TYPES = ["test", "exam"];
var normalizeTestSessionType = (value) => value === "test" || value === "exam" ? "timed_test" : value;
var zLegacyTestSessionTypeRead = z.enum([...TEST_SESSION_TYPES, ...LEGACY_TEST_SESSION_TYPES]).transform(normalizeTestSessionType);
var normalizeGradeLetter = (value) => zGradeLetter.parse(value);
var zLegacyGradeLetterRead = z.string().pipe(zGradeLetter);

// src/transitions/types.ts
var InvalidTransitionError = class extends Error {
  constructor(domain, from, to) {
    super(`invalid ${domain} transition: ${from} \u2192 ${to}`);
    this.name = "InvalidTransitionError";
    this.domain = domain;
    this.from = from;
    this.to = to;
  }
};

// src/transitions/space.ts
var SPACE_TRANSITIONS = {
  draft: ["published"],
  published: ["archived", "draft"],
  archived: ["draft"]
};

// src/transitions/exam.ts
var EXAM_TRANSITIONS = {
  draft: ["question_paper_uploaded", "archived"],
  question_paper_uploaded: ["question_paper_extracted", "archived"],
  question_paper_extracted: ["published", "archived"],
  published: ["grading", "archived"],
  grading: ["results_released", "grading"],
  results_released: ["archived"],
  archived: []
};

// src/transitions/submission.ts
var SUBMISSION_TRANSITIONS = {
  uploaded: ["scouting"],
  scouting: ["scouting_complete", "scouting_failed"],
  scouting_failed: ["scouting", "manual_review_needed"],
  scouting_complete: ["grading"],
  grading: ["grading_complete", "grading_partial", "grading_failed", "manual_review_needed"],
  grading_partial: ["grading"],
  grading_failed: ["grading", "manual_review_needed"],
  grading_complete: ["ready_for_review", "finalization_failed"],
  finalization_failed: ["grading_complete"],
  ready_for_review: ["reviewed"],
  reviewed: [],
  manual_review_needed: ["grading", "reviewed"],
  failed: []
};

// src/transitions/question-grading.ts
var QUESTION_GRADING_TRANSITIONS = {
  pending: ["processing"],
  processing: ["graded", "needs_review", "failed"],
  graded: ["overridden"],
  needs_review: ["graded", "manual", "overridden"],
  failed: ["pending", "manual"],
  manual: ["overridden"],
  overridden: []
};

// src/transitions/test-session.ts
var TEST_SESSION_TRANSITIONS = {
  in_progress: ["completed", "expired", "abandoned"],
  completed: [],
  expired: [],
  abandoned: []
};

// src/transitions/tenant.ts
var TENANT_TRANSITIONS = {
  trial: ["active", "expired", "suspended", "deactivated"],
  active: ["suspended", "deactivated", "expired"],
  suspended: ["active", "deactivated"],
  expired: ["active", "deactivated"],
  deactivated: ["active"]
};
var MEMBERSHIP_TRANSITIONS = {
  active: ["inactive", "suspended"],
  inactive: ["active"],
  suspended: ["active", "inactive"]
};
var ENTITY_STATUS_TRANSITIONS = {
  active: ["archived"],
  archived: ["active"]
};
var ANNOUNCEMENT_TRANSITIONS = {
  draft: ["published", "archived"],
  published: ["archived"],
  archived: ["draft"]
};

// src/transitions/index.ts
var ALLOWED_TRANSITIONS = {
  space: SPACE_TRANSITIONS,
  exam: EXAM_TRANSITIONS,
  submission: SUBMISSION_TRANSITIONS,
  questionGrading: QUESTION_GRADING_TRANSITIONS,
  testSession: TEST_SESSION_TRANSITIONS,
  tenant: TENANT_TRANSITIONS,
  membership: MEMBERSHIP_TRANSITIONS,
  entityStatus: ENTITY_STATUS_TRANSITIONS,
  announcement: ANNOUNCEMENT_TRANSITIONS
};
var canTransition = (domain, from, to) => {
  const map = ALLOWED_TRANSITIONS[domain];
  const targets = map?.[from];
  return targets != null && targets.includes(to);
};
var assertTransition = (domain, from, to) => {
  if (!canTransition(domain, from, to)) {
    throw new InvalidTransitionError(domain, String(from), to);
  }
};
var FeedbackItemSchema = zObject({
  severity: zFeedbackSeverity,
  message: z.string(),
  dimension: z.string().optional(),
  suggestion: z.string().optional()
});
var EvaluationSummarySchema = zObject({
  keyTakeaway: z.string(),
  overallComment: z.string()
});
var EvaluationSummaryInputSchema = z.union([
  EvaluationSummarySchema,
  z.string().transform((s) => ({ keyTakeaway: s, overallComment: s }))
]);
var RubricBreakdownItemSchema = zObject({
  criterionId: z.string().optional(),
  criterionName: z.string(),
  score: z.number(),
  maxScore: z.number(),
  comment: z.string().optional()
});
var UnifiedEvaluationResultSchema = zObject({
  score: z.number(),
  maxScore: z.number(),
  correctness: z.number(),
  percentage: z.number(),
  structuredFeedback: z.record(z.string(), z.array(FeedbackItemSchema)).optional(),
  strengths: z.array(z.string()).default([]),
  weaknesses: z.array(z.string()).default([]),
  missingConcepts: z.array(z.string()).default([]),
  rubricBreakdown: z.array(RubricBreakdownItemSchema).optional(),
  summary: EvaluationSummaryInputSchema.optional(),
  confidence: z.number(),
  mistakeClassification: zMistakeClassification.optional(),
  // ⚷ cost telemetry — projected out for clients.
  tokensUsed: z.number().optional(),
  costUsd: z.number().optional(),
  evaluationRubricId: z.string().optional(),
  dimensionsUsed: z.array(z.string()).optional(),
  gradedAt: zTimestamp
});
var StoredEvaluationSummarySchema = zObject({
  keyTakeaway: z.string(),
  overallComment: z.string()
});
var StoredEvaluationSchema = zObject({
  score: z.number(),
  maxScore: z.number(),
  correctness: z.number(),
  percentage: z.number(),
  strengths: z.array(z.string()).default([]),
  weaknesses: z.array(z.string()).default([]),
  missingConcepts: z.array(z.string()).default([]),
  summary: StoredEvaluationSummarySchema.optional(),
  mistakeClassification: zMistakeClassification.optional(),
  // Evaluation-Core enrichments (AI-EVALUATION-CORE-PLAN.md D7) — optional so
  // pre-existing stored evaluations stay valid.
  confidence: z.number().optional(),
  structuredFeedback: z.record(z.string(), z.array(FeedbackItemSchema)).optional(),
  rubricBreakdown: z.array(RubricBreakdownItemSchema).optional()
});
var QuestionPayloadSchema = zObject({
  type: z.literal("question"),
  basePoints: z.number().optional(),
  explanation: z.string().optional(),
  questionData: QuestionTypeDataSchema
});
var TextMaterialSchema = zObject({ materialType: z.literal("text"), body: z.string() });
var VideoMaterialSchema = zObject({
  materialType: z.literal("video"),
  url: z.string(),
  durationSeconds: z.number().int().optional()
});
var PdfMaterialSchema = zObject({ materialType: z.literal("pdf"), url: z.string() });
var LinkMaterialSchema = zObject({
  materialType: z.literal("link"),
  url: z.string(),
  label: z.string().optional()
});
var InteractiveMaterialSchema = zObject({
  materialType: z.literal("interactive"),
  embedUrl: z.string()
});
var StoryMaterialSchema = zObject({
  materialType: z.literal("story"),
  slides: z.array(z.object({ title: z.string().optional(), body: z.string() }).strict())
});
var RichMaterialSchema = zObject({
  materialType: z.literal("rich"),
  blocks: z.array(z.unknown()),
  title: z.string().optional(),
  subtitle: z.string().optional(),
  coverImage: z.string().optional(),
  tags: z.array(z.string()).optional(),
  author: zObject({
    name: z.string(),
    avatar: z.string().optional(),
    bio: z.string().optional()
  }).optional(),
  readingTime: z.number().nonnegative().optional()
});
var MaterialDataSchema = z.discriminatedUnion("materialType", [
  TextMaterialSchema,
  VideoMaterialSchema,
  PdfMaterialSchema,
  LinkMaterialSchema,
  InteractiveMaterialSchema,
  StoryMaterialSchema,
  RichMaterialSchema
]);
var MaterialPayloadSchema = zObject({
  type: z.literal("material"),
  materialData: MaterialDataSchema
});
var InteractivePayloadSchema = zObject({
  type: z.literal("interactive"),
  interactiveType: zInteractiveType,
  config: z.record(z.string(), z.unknown()).optional(),
  embedUrl: z.string().optional()
});
var AssessmentPayloadSchema = zObject({
  type: z.literal("assessment"),
  assessmentType: zItemAssessmentType,
  durationMinutes: z.number().int().optional(),
  passingPercentage: z.number().optional()
});
var DiscussionPayloadSchema = zObject({
  type: z.literal("discussion"),
  threadType: zDiscussionThreadType,
  prompt: z.string()
});
var ProjectPayloadSchema = zObject({
  type: z.literal("project"),
  brief: z.string(),
  deliverables: z.array(z.string()).optional(),
  rubricDriven: z.boolean().optional()
});
var CheckpointPayloadSchema = zObject({
  type: z.literal("checkpoint"),
  message: z.string().optional(),
  requiresAcknowledgement: z.boolean().optional()
});
var ItemPayloadSchema = z.discriminatedUnion("type", [
  QuestionPayloadSchema,
  MaterialPayloadSchema,
  InteractivePayloadSchema,
  AssessmentPayloadSchema,
  DiscussionPayloadSchema,
  ProjectPayloadSchema,
  CheckpointPayloadSchema
]);
var PyqInfoSchema = zObject({
  year: z.number().int(),
  examName: z.string(),
  marks: z.number().optional()
});
var ItemMetadataSchema = zObject({
  totalPoints: z.number().optional(),
  maxMarks: z.number().optional(),
  estimatedTime: z.number().optional(),
  learningObjectives: z.array(z.string()).optional(),
  skillsAssessed: z.array(z.string()).optional(),
  bloomsLevel: zBloomsLevel.optional(),
  prerequisites: z.array(z.string()).optional(),
  isRetriable: z.boolean().optional(),
  evaluatorAgentId: zAgentId.optional(),
  pyqInfo: z.array(PyqInfoSchema).optional(),
  featured: z.boolean().optional(),
  viewCount: z.number().int().optional(),
  successRate: z.number().optional(),
  migrationSource: z.string().optional()
});
var ItemAnalyticsSchema = zObject({
  difficulty: z.number().optional(),
  topics: z.array(z.string()).optional(),
  cognitiveLoad: z.number().optional(),
  conceptImportance: z.number().optional(),
  attemptCount: z.number().int().optional(),
  averageScore: z.number().optional()
});
var ItemAttachmentSchema = zObject({
  id: z.string().optional(),
  type: zItemAttachmentType,
  url: z.string().min(1),
  name: z.string().optional(),
  mimeType: z.string().optional(),
  sizeBytes: z.number().int().nonnegative().optional()
});
var UnifiedItemSchema = zObject({
  id: zItemId,
  spaceId: zSpaceId,
  storyPointId: zStoryPointId,
  sectionId: zSectionId.optional(),
  tenantId: zTenantId,
  type: zItemType,
  payload: ItemPayloadSchema,
  title: z.string().optional(),
  content: z.string().optional(),
  difficulty: zDifficulty.optional(),
  topics: z.array(z.string()).optional(),
  labels: z.array(z.string()).optional(),
  orderIndex: z.number().int(),
  meta: ItemMetadataSchema.optional(),
  analytics: ItemAnalyticsSchema.optional(),
  // Resolved snapshot + source ref (REVIEW open-Q resolution).
  rubric: UnifiedRubricSchema.optional(),
  rubricId: zRubricPresetId.optional(),
  linkedQuestionId: zExamQuestionId.optional(),
  attachments: z.array(ItemAttachmentSchema).optional(),
  version: z.number().int().optional(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  createdBy: zUserId,
  updatedBy: zUserId,
  archivedAt: zTimestamp.nullable()
});
var AnswerKeySchema = zObject({
  id: zAnswerKeyId,
  itemId: zItemId,
  questionType: zQuestionType,
  correctAnswer: z.unknown(),
  acceptableAnswers: z.array(z.unknown()).optional(),
  // ⚷ leak how to score.
  evaluationGuidance: z.string().optional(),
  modelAnswer: z.string().optional(),
  // Chat-agent assessment-only private objectives. These stay in the deny-all
  // answer-key document and are never projected to learners.
  privateEvaluationObjectives: z.array(AgentAssessmentPrivateObjectiveSchema).optional(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp
});
var RubricPresetSchema = zObject({
  id: zRubricPresetId,
  tenantId: zTenantId,
  name: z.string(),
  description: z.string().optional(),
  rubric: UnifiedRubricSchema,
  category: zRubricPresetCategory,
  questionTypes: z.array(zQuestionType).optional(),
  isDefault: z.boolean(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp
});
var QuestionBankItemSchema = zObject({
  id: zQuestionBankItemId,
  tenantId: zTenantId,
  questionType: zQuestionType,
  title: z.string().optional(),
  content: z.string(),
  explanation: z.string().optional(),
  basePoints: z.number().optional(),
  questionData: QuestionTypeDataSchema,
  subject: z.string(),
  topics: z.array(z.string()),
  difficulty: zDifficulty,
  bloomsLevel: zBloomsLevel.optional(),
  usageCount: z.number().int().default(0),
  averageScore: z.number().optional(),
  lastUsedAt: zTimestamp.nullable(),
  tags: z.array(z.string()).default([]),
  createdAt: zTimestamp,
  updatedAt: zTimestamp
});
var ContentVersionSchema = zObject({
  id: zContentVersionId,
  version: z.number().int(),
  entityType: zContentVersionEntityType,
  entityId: z.string(),
  changeType: zContentChangeType,
  changeSummary: z.string(),
  changedBy: zUserId,
  changedAt: zTimestamp
});
var PurchaseRecordSchema = zObject({
  spaceId: zSpaceId,
  spaceTitle: z.string(),
  amount: zMoney,
  purchasedAt: zTimestamp,
  transactionId: z.string()
});
var ConsumerProfileSchema = zObject({
  plan: zConsumerPlan,
  enrolledSpaceIds: z.array(zSpaceId).default([]),
  purchaseHistory: z.array(PurchaseRecordSchema).default([]),
  totalSpend: zMoney.optional()
});
var UserPreferencesSchema = zObject({
  theme: z.string().optional(),
  language: z.string().optional(),
  notificationsEnabled: z.boolean().optional()
});
var UnifiedUserSchema = zObject({
  uid: zUserId,
  email: z.string().optional(),
  phone: z.string().optional(),
  authProviders: z.array(zAuthProvider).default([]),
  displayName: z.string(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  photoURL: z.string().optional(),
  country: z.string().optional(),
  age: z.number().int().optional(),
  grade: z.string().optional(),
  onboardingCompleted: z.boolean().optional(),
  preferences: UserPreferencesSchema.optional(),
  isSuperAdmin: z.boolean(),
  consumerProfile: ConsumerProfileSchema.optional(),
  activeTenantId: zTenantId.optional(),
  status: zUserStatus,
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  createdBy: zUserId,
  updatedBy: zUserId,
  lastLogin: zTimestamp.nullable()
});
var TeacherPermissionsSchema = zObject({
  permissions: z.partialRecord(zTeacherPermissionKey, z.boolean()).optional(),
  managedSpaceIds: z.array(zSpaceId).optional(),
  managedClassIds: z.array(zClassId).optional()
});
var UserMembershipSchema = zObject({
  id: zMembershipId,
  uid: zUserId,
  tenantId: zTenantId,
  tenantCode: zTenantCode,
  role: zTenantRole,
  status: zMembershipStatus,
  joinSource: zJoinSource,
  // Per-role id fields DERIVED from ID_ROLES (DP-2 Part B).
  ...roleIdFields,
  permissions: TeacherPermissionsSchema.optional(),
  staffPermissions: z.partialRecord(zStaffPermissionKey, z.boolean()).optional(),
  parentLinkedStudentIds: z.array(zStudentId).optional(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  createdBy: zUserId,
  updatedBy: zUserId,
  lastActive: zTimestamp.nullable()
});
var PlatformClaimsSchema = zObject({
  role: zTenantRole.optional(),
  tenantId: zTenantId.optional(),
  tenantCode: zTenantCode.optional(),
  // Per-role id fields (teacherId/studentId/parentId/scannerId/staffId) DERIVED
  // from ID_ROLES (DP-2 Part B) — a new role's id field appears here automatically.
  ...roleIdFields,
  classIds: z.array(zClassId).optional(),
  classIdsOverflow: z.boolean().optional(),
  studentIds: z.array(zStudentId).optional(),
  permissions: z.partialRecord(zTeacherPermissionKey, z.boolean()).optional(),
  staffPermissions: z.partialRecord(zStaffPermissionKey, z.boolean()).optional(),
  isSuperAdmin: z.boolean().optional()
});
var TenantSubscriptionSchema = zObject({
  plan: zTenantPlan,
  maxStudents: z.number().int().optional(),
  maxTeachers: z.number().int().optional(),
  maxExamsPerMonth: z.number().int().optional(),
  maxAiCallsPerMonth: z.number().int().optional(),
  renewsAt: zTimestamp.nullable()
});
var TenantFeaturesSchema = zObject({
  autograde: z.boolean().optional(),
  levelup: z.boolean().optional(),
  analytics: z.boolean().optional(),
  store: z.boolean().optional(),
  // Conversational AI is explicit-on: omitted means disabled. The root switch
  // and the mode-specific switch must both be true before a session can start.
  conversations: z.boolean().optional(),
  conversationTutor: z.boolean().optional(),
  conversationQuestionHelp: z.boolean().optional(),
  conversationAssessment: z.boolean().optional()
});
var TenantSettingsSchema = zObject({
  // Secret Manager reference ONLY — never the key value.
  geminiKeyRef: z.string().optional(),
  timezone: z.string().optional(),
  locale: z.string().optional(),
  gradingScale: z.string().optional()
});
var TenantStatsSchema = zObject({
  totalStudents: z.number().int().default(0),
  totalTeachers: z.number().int().default(0),
  totalClasses: z.number().int().default(0),
  totalExams: z.number().int().default(0),
  totalSpaces: z.number().int().default(0)
});
var TenantUsageSchema = zObject({
  examsThisMonth: z.number().int().default(0),
  aiCallsThisMonth: z.number().int().default(0),
  resetAt: zTimestamp.nullable()
});
var TenantBrandingSchema = zObject({
  logoUrl: z.string().optional(),
  bannerUrl: z.string().optional(),
  faviconUrl: z.string().optional(),
  primaryColor: z.string().optional(),
  secondaryColor: z.string().optional()
});
var TenantOnboardingSchema = zObject({
  completed: z.boolean().default(false),
  steps: z.array(z.string()).optional(),
  completedAt: zTimestamp.nullable()
});
var TenantDeactivationSchema = zObject({
  reason: z.string().optional(),
  deactivatedBy: zUserId.optional(),
  deactivatedAt: zTimestamp.nullable()
});
var TenantSchema = zObject({
  id: zTenantId,
  name: z.string(),
  shortName: z.string().optional(),
  slug: z.string(),
  tenantCode: zTenantCode,
  ownerUid: zUserId,
  status: zTenantStatus,
  subscription: TenantSubscriptionSchema,
  features: TenantFeaturesSchema,
  settings: TenantSettingsSchema,
  stats: TenantStatsSchema,
  usage: TenantUsageSchema.optional(),
  branding: TenantBrandingSchema.optional(),
  onboarding: TenantOnboardingSchema.optional(),
  deactivation: TenantDeactivationSchema.optional(),
  contactEmail: z.string().optional(),
  contactPhone: z.string().optional(),
  trialEndsAt: zTimestamp.nullable(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  createdBy: zUserId,
  updatedBy: zUserId
});
var TenantCodeIndexSchema = zObject({
  tenantId: zTenantId,
  createdAt: zTimestamp
});
var TenantPublicViewSchema = zObject({
  tenantId: zTenantId,
  name: z.string(),
  status: zTenantStatus,
  // Pre-auth trial-expiry signal (login gates). Optional: deployed backends that
  // predate this field must keep passing literal-true response validation.
  trialEndsAt: zTimestamp.nullable().optional(),
  branding: TenantBrandingSchema.optional()
});
function evaluateTenantAccess(tenant, now = /* @__PURE__ */ new Date()) {
  if (tenant.status === "active") return { allowed: true, trial: false };
  if (tenant.status === "trial") {
    const ends = tenant.trialEndsAt ? Date.parse(tenant.trialEndsAt) : Number.NaN;
    if (Number.isFinite(ends) && ends <= now.getTime()) {
      return { allowed: false, reason: "trial_expired" };
    }
    return { allowed: true, trial: true };
  }
  if (tenant.status === "expired") return { allowed: false, reason: "trial_expired" };
  return { allowed: false, reason: "inactive" };
}
var StudentSchema = zObject({
  id: zStudentId,
  tenantId: zTenantId,
  authUid: zUserId.optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  displayName: z.string().optional(),
  email: z.string().optional(),
  rollNumber: z.string().optional(),
  section: z.string().optional(),
  classIds: z.array(zClassId).default([]),
  parentIds: z.array(zParentId).default([]),
  grade: z.string().optional(),
  admissionNumber: z.string().optional(),
  dateOfBirth: zIsoDate.optional(),
  status: zEntityStatus,
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  createdBy: zUserId,
  updatedBy: zUserId
});
var TeacherSchema = zObject({
  id: zTeacherId,
  tenantId: zTenantId,
  authUid: zUserId.optional(),
  email: z.string().optional(),
  phone: z.string().optional(),
  firstName: z.string(),
  lastName: z.string(),
  displayName: z.string().optional(),
  employeeId: z.string().optional(),
  department: z.string().optional(),
  subjects: z.array(z.string()).default([]),
  designation: z.string().optional(),
  classIds: z.array(zClassId).default([]),
  sectionIds: z.array(zSectionId).optional(),
  status: zEntityStatus,
  lastLogin: zTimestamp.nullable(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  createdBy: zUserId,
  updatedBy: zUserId
});
var ParentSchema = zObject({
  id: zParentId,
  tenantId: zTenantId,
  authUid: zUserId.optional(),
  email: z.string().optional(),
  phone: z.string().optional(),
  firstName: z.string(),
  lastName: z.string(),
  displayName: z.string().optional(),
  studentIds: z.array(zStudentId).default([]),
  linkedStudentNames: z.array(z.string()).optional(),
  status: zEntityStatus,
  lastLogin: zTimestamp.nullable(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  createdBy: zUserId,
  updatedBy: zUserId
});
var StaffSchema = zObject({
  id: zStaffId,
  tenantId: zTenantId,
  authUid: zUserId.optional(),
  email: z.string().optional(),
  firstName: z.string(),
  lastName: z.string(),
  displayName: z.string().optional(),
  department: z.string().optional(),
  status: zEntityStatus,
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  createdBy: zUserId,
  updatedBy: zUserId
});
var ScannerSchema = zObject({
  id: zScannerId,
  tenantId: zTenantId,
  authUid: zUserId,
  name: z.string(),
  status: zEntityStatus,
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  createdBy: zUserId,
  updatedBy: zUserId
});
var ClassSchema = zObject({
  id: zClassId,
  tenantId: zTenantId,
  name: z.string(),
  grade: z.string(),
  section: z.string().optional(),
  academicSessionId: zAcademicSessionId.optional(),
  teacherIds: z.array(zTeacherId).default([]),
  studentIds: z.array(zStudentId).default([]),
  studentCount: z.number().int().default(0),
  status: zEntityStatus,
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  createdBy: zUserId,
  updatedBy: zUserId
});
var AcademicSessionSchema = zObject({
  id: zAcademicSessionId,
  tenantId: zTenantId,
  name: z.string(),
  startDate: zIsoDate,
  endDate: zIsoDate,
  isCurrent: z.boolean(),
  status: zEntityStatus,
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  createdBy: zUserId,
  updatedBy: zUserId
});
var UserProviderKeySchema = zObject({
  // `${userId}:${provider}` — one key per user per provider.
  id: z.string(),
  userId: zUserId,
  provider: zKeyProvider,
  // Secret Manager secret name (opaque ref) — NEVER the key value.
  secretRef: z.string(),
  // Display hint only, e.g. "AIza…4f2c" (first-4…last-4). Never enough to use.
  maskedKey: z.string(),
  status: zKeyStatus,
  // User's opt-in to actually route their calls through this key.
  enabled: z.boolean().default(true),
  label: z.string().optional(),
  // Where the key was first created (audit only; the key stays user-global).
  createdInTenantId: zTenantId.optional(),
  // Increments on each rotation (each Secret Manager version).
  version: z.number().int().default(1),
  // Last successful provider-side validation.
  validatedAt: zTimestamp.nullable(),
  lastUsedAt: zTimestamp.nullable(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp
});
var UserProviderKeyViewSchema = zObject({
  provider: zKeyProvider,
  maskedKey: z.string(),
  status: zKeyStatus,
  enabled: z.boolean(),
  label: z.string().optional(),
  version: z.number().int(),
  validatedAt: zTimestamp.nullable(),
  updatedAt: zTimestamp
});
var OwnedKeyStatusSchema = zObject({
  provider: zKeyProvider,
  present: z.boolean(),
  maskedKey: z.string().optional(),
  status: zKeyStatus.optional(),
  version: z.number().int().optional(),
  updatedAt: zTimestamp.nullable()
});
var userProviderKeyId = (userId, provider) => `${userId}:${provider}`;
var maskKey = (raw) => {
  const k = raw.trim();
  if (k.length <= 8) return "\u2022".repeat(Math.max(k.length, 4));
  return `${k.slice(0, 4)}\u2026${k.slice(-4)}`;
};
var SpaceStatsSchema = zObject({
  storyPointCount: z.number().int().nonnegative().default(0),
  itemCount: z.number().int().nonnegative().default(0),
  enrolledCount: z.number().int().nonnegative().default(0),
  completionCount: z.number().int().nonnegative().default(0)
});
var SpaceRatingAggregateSchema = zObject({
  averageRating: z.number().min(0).max(5),
  totalReviews: z.number().int().nonnegative(),
  distribution: z.record(z.string(), z.number().int().nonnegative())
});
var SpaceSchema = zObject({
  id: zSpaceId,
  tenantId: zTenantId,
  title: z.string().min(1).max(200),
  description: z.string().optional(),
  thumbnailUrl: z.string().optional(),
  slug: z.string().optional(),
  type: zSpaceType,
  subject: z.string().optional(),
  labels: z.array(z.string()).optional(),
  classIds: z.array(zClassId).default([]),
  sectionIds: z.array(zSectionId).optional(),
  teacherIds: z.array(zTeacherId).default([]),
  accessType: zSpaceAccessType,
  academicSessionId: zAcademicSessionId.optional(),
  defaultEvaluatorAgentId: zAgentId.optional(),
  defaultTutorAgentId: zAgentId.optional(),
  defaultRubric: UnifiedRubricSchema.optional(),
  defaultRubricId: zRubricPresetId.optional(),
  // Space-level evaluation-settings ref (AI-EVALUATION-CORE-PLAN.md D3):
  // shared tenant pool; resolution space → tenant default.
  evaluationSettingsId: zEvaluationSettingsId.optional(),
  // assessment defaults (space-level, applied to timed_test/quiz story points)
  allowRetakes: z.boolean().optional(),
  maxRetakes: z.number().int().nonnegative().optional(),
  defaultTimeLimitMinutes: z.number().int().nonnegative().optional(),
  showCorrectAnswers: z.boolean().optional(),
  // store fields
  price: zMoney.optional(),
  publishedToStore: z.boolean().optional(),
  storeDescription: z.string().optional(),
  storeThumbnailUrl: z.string().optional(),
  // lifecycle
  status: zSpaceStatus,
  publishedAt: zTimestamp.nullable(),
  // ⚷ denormalized
  stats: SpaceStatsSchema.optional(),
  ratingAggregate: SpaceRatingAggregateSchema.optional(),
  version: z.number().int().optional(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  createdBy: zUserId,
  updatedBy: zUserId,
  archivedAt: zTimestamp.nullable()
});
var StoryPointSectionSchema = zObject({
  id: zSectionId,
  title: z.string(),
  description: z.string().optional(),
  orderIndex: z.number().int()
});
var AssessmentScheduleSchema = zObject({
  opensAt: zTimestamp.nullable(),
  closesAt: zTimestamp.nullable()
}).refine(({ opensAt, closesAt }) => opensAt === null || closesAt === null || opensAt < closesAt, {
  message: "closesAt must be later than opensAt",
  path: ["closesAt"]
});
var RetryConfigSchema = zObject({
  cooldownMinutes: z.number().int().nonnegative().optional(),
  lockAfterPassing: z.boolean().optional()
});
var AdaptiveConfigSchema = zObject({
  enabled: z.boolean(),
  startingDifficulty: zDifficulty.optional(),
  stepUpThreshold: z.number().int().positive().optional(),
  stepDownThreshold: z.number().int().positive().optional()
});
var AssessmentConfigSchema = zObject({
  durationMinutes: z.number().int().positive().optional(),
  maxAttempts: z.number().int().positive().optional(),
  shuffle: z.boolean().optional(),
  passingPercentage: z.number().min(0).max(100).optional(),
  adaptiveConfig: AdaptiveConfigSchema.optional(),
  schedule: AssessmentScheduleSchema.optional(),
  retryConfig: RetryConfigSchema.optional()
});
var StoryPointStatsSchema = zObject({
  itemCount: z.number().int().nonnegative().default(0),
  completionCount: z.number().int().nonnegative().default(0)
});
var StoryPointSchema = zObject({
  id: zStoryPointId,
  spaceId: zSpaceId,
  tenantId: zTenantId,
  title: z.string(),
  description: z.string().optional(),
  orderIndex: z.number().int(),
  type: zStoryPointType,
  sections: z.array(StoryPointSectionSchema).default([]),
  assessmentConfig: AssessmentConfigSchema.optional(),
  defaultRubric: UnifiedRubricSchema.optional(),
  defaultRubricId: zRubricPresetId.optional(),
  difficulty: zDifficulty.optional(),
  estimatedTimeMinutes: z.number().int().nonnegative().optional(),
  stats: StoryPointStatsSchema.optional(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  createdBy: zUserId,
  updatedBy: zUserId,
  archivedAt: zTimestamp.nullable()
});
var CONVERSATION_MODES = ["tutor", "question_help", "agent_assessment"];
var zConversationMode = z.enum(CONVERSATION_MODES);
var CONVERSATION_SESSION_STATUSES = [
  "active",
  "ready_to_finish",
  "finalizing",
  "grading_pending",
  "grading_failed",
  "completed",
  "abandoned"
];
var zConversationSessionStatus = z.enum(CONVERSATION_SESSION_STATUSES);
var CONVERSATION_TURN_STATUSES = [
  "claimed",
  "model_running",
  "tool_running",
  "completed",
  "failed_recoverable",
  "failed_terminal"
];
var zConversationTurnStatus = z.enum(CONVERSATION_TURN_STATUSES);
var SUBMISSION_WORKFLOW_STATUSES = [
  "frozen",
  "grading_pending",
  "grading",
  "grading_failed",
  "evaluated",
  "progress_applied"
];
var zSubmissionWorkflowStatus = z.enum(SUBMISSION_WORKFLOW_STATUSES);
var MODEL_POLICY_IDS = [
  "conversation.fast",
  "conversation.quality",
  "evaluation.quality"
];
var zModelPolicyId = z.enum(MODEL_POLICY_IDS);
var CONVERSATION_TOOL_NAMES = [
  "retrieve_scope_context",
  "get_learner_visible_progress_summary",
  "recommend_learning_content",
  "retrieve_item_context",
  "record_hint_usage",
  "record_evidence",
  "recommend_completion"
];
var zConversationToolName = z.enum(CONVERSATION_TOOL_NAMES);
var TutorSpaceContextSchema = zObject({
  kind: z.literal("tutor"),
  scope: z.literal("space"),
  spaceId: zSpaceId
});
var TutorStoryPointContextSchema = zObject({
  kind: z.literal("tutor"),
  scope: z.literal("story_point"),
  spaceId: zSpaceId,
  storyPointId: zStoryPointId
});
var TutorItemContextSchema = zObject({
  kind: z.literal("tutor"),
  scope: z.literal("item"),
  spaceId: zSpaceId,
  storyPointId: zStoryPointId,
  itemId: zItemId
});
var TutorContextSchema = z.union([
  TutorSpaceContextSchema,
  TutorStoryPointContextSchema,
  TutorItemContextSchema
]);
var QuestionHelpContextSchema = zObject({
  kind: z.literal("question_help"),
  spaceId: zSpaceId,
  storyPointId: zStoryPointId,
  itemId: zItemId,
  attemptId: z.string().optional()
});
var AgentAssessmentContextSchema = zObject({
  kind: z.literal("agent_assessment"),
  spaceId: zSpaceId,
  storyPointId: zStoryPointId,
  itemId: zItemId,
  // Allocated by the server when a non-resumable assessment attempt starts.
  attemptNumber: z.number().int().positive()
});
var ConversationContextSchema = z.union([
  TutorContextSchema,
  QuestionHelpContextSchema,
  AgentAssessmentContextSchema
]);
var StartConversationContextSchema = z.union([
  TutorContextSchema,
  QuestionHelpContextSchema,
  AgentAssessmentContextSchema.omit({ attemptNumber: true })
]);
var ConversationContentBlockSchema = z.discriminatedUnion("type", [
  zObject({ type: z.literal("text"), text: z.string() }),
  zObject({
    type: z.literal("media"),
    // Phases 1–5 deliberately support only the existing gateway image seam.
    mediaKind: z.literal("image"),
    storagePath: z.string(),
    mimeType: z.string(),
    altText: z.string().optional()
  }),
  zObject({
    type: z.literal("citation"),
    sourceId: z.string(),
    label: z.string(),
    itemId: zItemId.optional(),
    storyPointId: zStoryPointId.optional()
  })
]);
var ConversationLeaseSchema = zObject({
  token: z.string(),
  ownerRequestId: z.string(),
  acquiredAt: zTimestamp,
  expiresAt: zTimestamp
});
var ConversationErrorSchema = zObject({
  // App-error codes live in api-contract; domain deliberately stores only the
  // canonical code string to preserve its no-upward-dependency boundary.
  code: z.string(),
  retryable: z.boolean(),
  safeMessage: z.string()
});
var ConversationMessageSchema = zObject({
  id: zConversationMessageId,
  sessionId: zConversationSessionId,
  sequence: z.number().int().positive(),
  role: z.enum(["learner", "assistant"]),
  /** Opening messages are explicit; all later messages are attached to a turn. */
  origin: z.enum(["opening", "turn"]),
  content: z.array(ConversationContentBlockSchema),
  turnId: zConversationTurnId.optional(),
  clientMessageId: z.string().optional(),
  deliveryStatus: z.enum(["accepted", "complete"]),
  createdAt: zTimestamp,
  completedAt: zTimestamp.optional(),
  redaction: zObject({
    status: z.enum(["none", "redacted"]),
    reasonCode: z.string().optional()
  }).optional()
}).superRefine((message, ctx) => {
  if (message.origin === "opening") {
    if (message.role !== "assistant") {
      ctx.addIssue({
        code: "custom",
        message: "only the deterministic first assistant message may use origin=opening",
        path: ["origin"]
      });
    }
    if (message.turnId !== void 0) {
      ctx.addIssue({
        code: "custom",
        message: "an opening message must not carry a turnId",
        path: ["turnId"]
      });
    }
  }
  if (message.origin === "turn" && message.turnId === void 0) {
    ctx.addIssue({
      code: "custom",
      message: "a turn-origin message must carry its matching turnId",
      path: ["turnId"]
    });
  }
});
var ConversationToolInvocationSchema = zObject({
  id: z.string(),
  step: z.number().int().nonnegative(),
  ordinal: z.number().int().nonnegative(),
  toolName: zConversationToolName,
  status: z.enum(["requested", "running", "succeeded", "failed"]),
  argsHash: z.string(),
  sanitizedArgs: zJsonValue,
  sanitizedResult: zJsonValue.optional(),
  resultBytes: z.number().int().nonnegative().optional(),
  startedAt: zTimestamp.optional(),
  completedAt: zTimestamp.optional(),
  errorCode: z.string().optional()
});
var ConversationTurnSchema = zObject({
  id: zConversationTurnId,
  sessionId: zConversationSessionId,
  clientMessageId: z.string(),
  learnerMessageId: zConversationMessageId,
  status: zConversationTurnStatus,
  attemptCount: z.number().int().nonnegative(),
  lease: ConversationLeaseSchema.optional(),
  promptVersion: z.string(),
  configurationFingerprint: z.string(),
  toolsetVersion: z.string(),
  modelPolicyId: zModelPolicyId,
  modelRequestIds: z.array(z.string()),
  toolInvocations: z.array(ConversationToolInvocationSchema),
  assistantMessageIds: z.array(zConversationMessageId),
  traceId: z.string(),
  error: ConversationErrorSchema.optional(),
  claimedAt: zTimestamp,
  completedAt: zTimestamp.optional()
});
var ConversationConfigurationSnapshotSchema = zObject({
  schemaVersion: z.literal(1),
  fingerprint: z.string(),
  mode: zConversationMode,
  locale: z.string(),
  prompt: zObject({
    key: z.enum(["conversationTutor", "conversationQuestionHelp", "conversationAssessment"]),
    version: z.string()
  }),
  safetyPolicy: zObject({ id: z.string(), version: z.string() }),
  toolset: zObject({
    id: z.string(),
    version: z.string(),
    toolNames: z.array(zConversationToolName)
  }),
  // Runtime and evaluator policies are intentionally distinct. Assessment
  // finalization must never inherit the interviewer/runtime model policy.
  runtimeModelPolicyId: zModelPolicyId,
  runtimeAgent: zObject({
    source: z.enum(["configured", "builtin"]),
    id: z.string(),
    version: z.number().int().nonnegative(),
    type: z.enum(["tutor", "interviewer"]),
    identity: z.string().optional(),
    systemPrompt: z.string().optional(),
    rules: z.array(z.string()),
    openingMessage: z.string().optional()
  }),
  context: zObject({
    contentVersions: z.array(
      zObject({
        resourceType: z.string(),
        resourceId: z.string(),
        version: z.number().int().nonnegative()
      })
    ),
    interviewerContext: zJsonValue,
    evaluatorContext: zObject({
      question: zJsonValue,
      answerKey: zJsonValue,
      rubric: zJsonValue,
      evaluationSettings: zJsonValue,
      evaluatorAgent: zJsonValue.optional(),
      evaluatorModelPolicyId: zModelPolicyId,
      evaluatorPromptVersion: z.string()
    }).optional()
  }),
  completionPolicy: ConversationCompletionPolicySchema.optional(),
  createdAt: zTimestamp
});
var ConversationPublicSourceVersionSchema = zObject({
  resourceType: z.enum(["space", "story_point", "item", "interviewer_agent"]),
  resourceId: z.string(),
  version: z.number().int().nonnegative()
});
var ConversationPublicConfigSchema = zObject({
  /** Static/config-derived greeting projected to the learner with the session. */
  openingMessage: z.string().optional(),
  publicLearningObjectives: z.array(ConversationPublicLearningObjectiveSchema).optional(),
  conversationStarters: z.array(z.string()).optional(),
  completionPolicy: ConversationCompletionPolicySchema.optional(),
  configurationFingerprint: z.string(),
  sourceVersions: z.array(ConversationPublicSourceVersionSchema)
});
var ConversationCompletionRecommendationSchema = zObject({
  reasonCode: z.enum([
    "objectives_covered",
    "learner_requested",
    "insufficient_new_evidence",
    "hard_limit"
  ]),
  coveredPublicObjectiveIds: z.array(z.string()),
  remainingPublicObjectiveIds: z.array(z.string()),
  hardLimitReached: z.boolean(),
  recommendedAt: zTimestamp
});
var ConversationFinalizationSchema = zObject({
  lease: ConversationLeaseSchema.optional(),
  frozenThroughSequence: z.number().int().nonnegative().optional(),
  frozenRevision: z.number().int().nonnegative().optional(),
  transcriptHash: z.string().optional(),
  submissionId: zItemSubmissionId.optional(),
  requestedReason: z.enum(["learner_requested", "hard_limit"]).optional(),
  earlyFinishConfirmed: z.boolean().optional(),
  startedAt: zTimestamp.optional(),
  completedAt: zTimestamp.optional()
});
var ConversationSafeResultSchema = zObject({
  submissionId: zItemSubmissionId,
  evaluation: StoredEvaluationSchema,
  progressApplied: z.boolean()
});
var ConversationGradingViewSchema = zObject({
  status: z.enum(["pending", "failed"]),
  retryable: z.boolean(),
  retryAfterMs: z.number().int().positive().optional(),
  safeMessage: z.string().optional()
});
var ConversationLastMessagePreviewSchema = z.string().max(160).refine((value) => value === value.trim().replace(/\s+/gu, " "), {
  message: "lastMessagePreview must be normalized whitespace"
});
var ConversationSessionDocSchema = zObject({
  schemaVersion: z.literal(1),
  id: zConversationSessionId,
  tenantId: zTenantId,
  ownerUid: zUserId,
  learnerStudentId: zStudentId.optional(),
  mode: zConversationMode,
  context: ConversationContextSchema,
  contextBaseKey: z.string(),
  contextKey: z.string(),
  title: z.string(),
  locale: z.string(),
  status: zConversationSessionStatus,
  publicConfig: ConversationPublicConfigSchema,
  configurationSnapshot: ConversationConfigurationSnapshotSchema,
  clientRequestId: z.string(),
  nextSequence: z.number().int().nonnegative(),
  revision: z.number().int().nonnegative(),
  learnerTurnCount: z.number().int().nonnegative(),
  activeTurnId: zConversationTurnId.optional(),
  activeTurnLeaseExpiresAt: zTimestamp.optional(),
  completionRecommendation: ConversationCompletionRecommendationSchema.optional(),
  finalization: ConversationFinalizationSchema.optional(),
  safeResult: ConversationSafeResultSchema.optional(),
  lastMessageAt: zTimestamp.optional(),
  lastMessagePreview: ConversationLastMessagePreviewSchema.optional(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  completedAt: zTimestamp.optional(),
  abandonedAt: zTimestamp.optional()
});
var ConversationSessionKeyDocSchema = zObject({
  schemaVersion: z.literal(1),
  id: z.string(),
  tenantId: zTenantId,
  ownerUid: zUserId,
  mode: zConversationMode,
  contextBaseKey: z.string(),
  activeSessionId: zConversationSessionId.optional(),
  nextAttemptNumber: z.number().int().positive(),
  revision: z.number().int().nonnegative(),
  updatedAt: zTimestamp
});
var ConversationTurnDocSchema = ConversationTurnSchema.extend({
  tenantId: zTenantId,
  ownerUid: zUserId,
  sessionRevisionAtClaim: z.number().int().nonnegative(),
  requestInputHash: z.string(),
  inputModeration: zJsonValue.optional(),
  outputModeration: zJsonValue.optional(),
  usageAggregate: zObject({
    inputTokens: z.number().int().nonnegative(),
    outputTokens: z.number().int().nonnegative(),
    cachedInputTokens: z.number().int().nonnegative(),
    costUsd: z.number().nonnegative()
  }).optional(),
  updatedAt: zTimestamp
}).strict();
var ConversationEvidenceDocSchema = zObject({
  schemaVersion: z.literal(1),
  id: zConversationEvidenceId,
  tenantId: zTenantId,
  sessionId: zConversationSessionId,
  turnId: zConversationTurnId,
  objectiveId: z.string(),
  rubricDimensionId: z.string(),
  messageSequences: z.array(z.number().int().positive()),
  note: z.string(),
  confidence: z.number().min(0).max(1),
  recorder: zObject({
    type: z.literal("interviewer_model"),
    promptVersion: z.string(),
    configurationFingerprint: z.string()
  }),
  createdAt: zTimestamp
});
var ItemSubmissionPayloadSchema = zObject({
  mode: z.literal("agent_assessment"),
  frozenThroughSequence: z.number().int().nonnegative(),
  transcript: z.array(
    zObject({
      sequence: z.number().int().positive(),
      role: z.enum(["learner", "assistant"]),
      content: z.array(ConversationContentBlockSchema),
      createdAt: zTimestamp
    })
  ),
  transcriptHash: z.string(),
  configurationSnapshot: ConversationConfigurationSnapshotSchema,
  configurationFingerprint: z.string(),
  finalizationReason: z.enum(["learner_requested", "hard_limit"]),
  earlyFinish: z.boolean(),
  frozenAt: zTimestamp
});
var ItemSubmissionWorkflowSchema = zObject({
  status: zSubmissionWorkflowStatus,
  evaluationLease: ConversationLeaseSchema.optional(),
  evaluationAttemptCount: z.number().int().nonnegative(),
  nextRetryAt: zTimestamp.optional(),
  lastError: ConversationErrorSchema.optional(),
  progressAppliedAt: zTimestamp.optional()
});
var ItemSubmissionEvaluationSchema = zObject({
  result: UnifiedEvaluationResultSchema,
  safeResult: StoredEvaluationSchema,
  resultHash: z.string(),
  evaluatorPromptVersion: z.string(),
  // Do not substitute runtimeModelPolicyId here. This is the evaluator policy
  // frozen independently in the assessment configuration snapshot.
  evaluatorModelPolicyId: zModelPolicyId,
  evaluatedAt: zTimestamp
});
var ItemSubmissionDocSchema = zObject({
  schemaVersion: z.literal(1),
  id: zItemSubmissionId,
  tenantId: zTenantId,
  ownerUid: zUserId,
  learnerStudentId: zStudentId.optional(),
  spaceId: zSpaceId,
  storyPointId: zStoryPointId,
  itemId: zItemId,
  sessionId: zConversationSessionId,
  attemptNumber: z.number().int().positive(),
  payload: ItemSubmissionPayloadSchema,
  workflow: ItemSubmissionWorkflowSchema,
  evaluation: ItemSubmissionEvaluationSchema.optional(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp
});
var ItemSubmissionEvaluationAttemptDocSchema = zObject({
  id: z.string(),
  submissionId: zItemSubmissionId,
  attemptNumber: z.number().int().positive(),
  leaseTokenHash: z.string(),
  status: z.enum(["running", "succeeded", "failed"]),
  gatewayRequestId: z.string().optional(),
  traceId: z.string(),
  errorCode: z.string().optional(),
  retryable: z.boolean().optional(),
  startedAt: zTimestamp,
  completedAt: zTimestamp.optional()
});
var ProgressApplicationDocSchema = zObject({
  schemaVersion: z.literal(1),
  id: zItemSubmissionId,
  tenantId: zTenantId,
  ownerUid: zUserId,
  spaceId: zSpaceId,
  storyPointId: zStoryPointId,
  itemId: zItemId,
  submissionId: zItemSubmissionId,
  evaluationResultHash: z.string(),
  score: z.number(),
  maxScore: z.number(),
  appliedAt: zTimestamp
});
var ConversationBumpSchema = zObject({
  rev: z.number().int().nonnegative(),
  lastMessageAt: zTimestamp.optional()
});
var ConversationSessionViewSchema = zObject({
  id: zConversationSessionId,
  mode: zConversationMode,
  context: ConversationContextSchema,
  contextBaseKey: z.string(),
  contextKey: z.string(),
  title: z.string(),
  locale: z.string(),
  status: zConversationSessionStatus,
  revision: z.number().int().nonnegative(),
  learnerTurnCount: z.number().int().nonnegative(),
  publicConfig: ConversationPublicConfigSchema,
  completionRecommendation: ConversationCompletionRecommendationSchema.optional(),
  activeTurn: zObject({
    id: zConversationTurnId,
    status: z.enum(["running", "failed_recoverable"]),
    clientMessageId: z.string()
  }).optional(),
  grading: ConversationGradingViewSchema.optional(),
  result: ConversationSafeResultSchema.optional(),
  allowedActions: z.array(z.enum(["send", "finish", "abandon", "retry_turn"])),
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  completedAt: zTimestamp.optional()
});
var ConversationMessageViewSchema = zObject({
  id: zConversationMessageId,
  sequence: z.number().int().positive(),
  role: z.enum(["learner", "assistant"]),
  origin: z.enum(["opening", "turn"]),
  content: z.array(ConversationContentBlockSchema),
  clientMessageId: z.string().optional(),
  deliveryStatus: z.enum(["accepted", "complete"]),
  createdAt: zTimestamp,
  completedAt: zTimestamp.optional()
});
var ConversationTurnViewSchema = zObject({
  id: zConversationTurnId,
  clientMessageId: z.string(),
  status: z.enum(["running", "completed", "failed_recoverable", "failed_terminal"]),
  assistantMessageIds: z.array(zConversationMessageId),
  error: ConversationErrorSchema.optional()
});
var ConversationSessionSummaryViewSchema = zObject({
  id: zConversationSessionId,
  mode: zConversationMode,
  context: ConversationContextSchema,
  contextBaseKey: z.string(),
  title: z.string(),
  locale: z.string(),
  status: zConversationSessionStatus,
  learnerTurnCount: z.number().int().nonnegative(),
  lastMessageAt: zTimestamp.optional(),
  lastMessagePreview: ConversationLastMessagePreviewSchema.optional(),
  updatedAt: zTimestamp,
  completedAt: zTimestamp.optional()
});
var ItemSubmissionViewSchema = zObject({
  id: zItemSubmissionId,
  sessionId: zConversationSessionId,
  attemptNumber: z.number().int().positive(),
  workflow: zObject({
    status: zSubmissionWorkflowStatus,
    retryable: z.boolean().optional(),
    nextRetryAt: zTimestamp.optional(),
    progressAppliedAt: zTimestamp.optional()
  }),
  evaluation: StoredEvaluationSchema.optional(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp
});

// src/entities/levelup/agent.ts
var AgentSchema = zObject({
  id: zAgentId,
  spaceId: zSpaceId,
  tenantId: zTenantId,
  type: zAgentType,
  name: z.string(),
  publicDescription: z.string().optional(),
  identity: z.string().optional(),
  isActive: z.boolean(),
  // tutor fields
  systemPrompt: z.string().optional(),
  supportedLanguages: z.array(z.string()).optional(),
  defaultLanguage: z.string().optional(),
  maxConversationTurns: z.number().int().optional(),
  // evaluator fields (rules → string[] per D12)
  rules: z.array(z.string()).optional(),
  /** Static/config-derived first assistant message; never generated at start. */
  openingMessage: z.string().optional(),
  /** Evaluator persona guidance only; never substitutes item-private objectives. */
  evaluationObjectives: z.array(z.string()).optional(),
  strictness: z.number().optional(),
  feedbackStyle: z.string().optional(),
  modelPolicyId: zModelPolicyId,
  temperatureOverride: z.number().optional(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  createdBy: zUserId,
  updatedBy: zUserId,
  // Incremented by the service for every semantic configuration update.
  version: z.number().int().positive()
});
var ConversationAgentSchema = AgentSchema;
var LegacyAgentReadSchema = zObject({
  ...AgentSchema.shape,
  modelPolicyId: zModelPolicyId.optional(),
  version: z.number().int().positive().optional(),
  modelOverride: z.string().optional()
}).transform(
  (legacy) => AgentSchema.parse({
    id: legacy.id,
    spaceId: legacy.spaceId,
    tenantId: legacy.tenantId,
    type: legacy.type,
    name: legacy.name,
    publicDescription: legacy.publicDescription,
    identity: legacy.identity,
    isActive: legacy.isActive,
    systemPrompt: legacy.systemPrompt,
    supportedLanguages: legacy.supportedLanguages,
    defaultLanguage: legacy.defaultLanguage,
    maxConversationTurns: legacy.maxConversationTurns,
    rules: legacy.rules,
    openingMessage: legacy.openingMessage,
    evaluationObjectives: legacy.evaluationObjectives,
    strictness: legacy.strictness,
    feedbackStyle: legacy.feedbackStyle,
    modelPolicyId: legacy.modelPolicyId ?? (legacy.type === "evaluator" ? "evaluation.quality" : "conversation.quality"),
    temperatureOverride: legacy.temperatureOverride,
    createdAt: legacy.createdAt,
    updatedAt: legacy.updatedAt,
    createdBy: legacy.createdBy,
    updatedBy: legacy.updatedBy,
    version: legacy.version ?? 1
  })
);
var AdaptiveStateSchema = zObject({
  currentDifficulty: zDifficulty,
  consecutiveCorrect: z.number().int().default(0),
  consecutiveIncorrect: z.number().int().default(0),
  answeredByDifficulty: z.record(z.string(), z.number().int()).optional()
});
var AnalyticsBreakdownEntrySchema = zObject({
  correct: z.number().int(),
  total: z.number().int(),
  points: z.number().optional(),
  maxPoints: z.number().optional()
});
var TestAnalyticsSchema = zObject({
  topicBreakdown: z.record(z.string(), AnalyticsBreakdownEntrySchema).optional(),
  bloomsBreakdown: z.record(z.string(), AnalyticsBreakdownEntrySchema).optional(),
  difficultyBreakdown: z.record(z.string(), AnalyticsBreakdownEntrySchema).optional(),
  sectionBreakdown: z.record(z.string(), AnalyticsBreakdownEntrySchema).optional(),
  timePerQuestion: z.record(z.string(), z.number()).optional(),
  averageTimePerQuestion: z.number().optional()
});
var DifficultyProgressionEntrySchema = zObject({
  questionIndex: z.number().int(),
  difficulty: zDifficulty,
  correct: z.boolean()
});
var DigitalTestSessionSchema = zObject({
  id: zTestSessionId,
  tenantId: zTenantId,
  userId: zUserId,
  spaceId: zSpaceId,
  storyPointId: zStoryPointId,
  sessionType: zTestSessionType,
  attemptNumber: z.number().int(),
  status: zTestSessionStatus,
  isLatest: z.boolean(),
  // timing (⚷ serverDeadline)
  startedAt: zTimestamp,
  endedAt: zTimestamp.nullable(),
  durationMinutes: z.number().int(),
  serverDeadline: zTimestamp.nullable(),
  // question tracking
  totalQuestions: z.number().int(),
  answeredQuestions: z.number().int().default(0),
  questionOrder: z.array(zItemId).default([]),
  // lightweight boolean maps kept inline (REVIEW D6)
  visitedQuestions: z.record(z.string(), z.boolean()).default({}),
  markedForReview: z.record(z.string(), z.boolean()).default({}),
  // scores (⚷ server-computed)
  pointsEarned: z.number().optional(),
  totalPoints: z.number().optional(),
  marksEarned: z.number().optional(),
  totalMarks: z.number().optional(),
  percentage: z.number().optional(),
  sectionMapping: z.record(z.string(), z.string()).optional(),
  lastVisitedIndex: z.number().int().optional(),
  // adaptive state
  adaptiveState: AdaptiveStateSchema.optional(),
  currentDifficultyLevel: zDifficulty.optional(),
  difficultyProgression: z.array(DifficultyProgressionEntrySchema).optional(),
  analytics: TestAnalyticsSchema.optional(),
  // audit
  submittedAt: zTimestamp.nullable(),
  autoSubmitted: z.boolean().optional(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp
});
var TestSubmissionSchema = zObject({
  itemId: zItemId,
  questionType: zQuestionType,
  answer: z.unknown(),
  submittedAt: zTimestamp,
  timeSpentSeconds: z.number().int().optional(),
  // post-grade (⚷)
  evaluation: UnifiedEvaluationResultSchema.optional(),
  correct: z.boolean().optional(),
  pointsEarned: z.number().optional(),
  totalPoints: z.number().optional()
});
var ChatMessageSchema = zObject({
  id: zChatMessageId,
  role: zChatMessageRole,
  text: z.string(),
  timestamp: zTimestamp,
  mediaUrls: z.array(z.string()).optional(),
  tokensUsed: z.number().int().optional()
});
var ChatSessionSchema = zObject({
  id: zChatSessionId,
  tenantId: zTenantId,
  userId: zUserId,
  spaceId: zSpaceId,
  storyPointId: zStoryPointId,
  itemId: zItemId,
  questionType: zQuestionType.optional(),
  agentId: zAgentId.optional(),
  agentName: z.string().optional(),
  sessionTitle: z.string(),
  previewMessage: z.string(),
  messageCount: z.number().int().default(0),
  language: z.string(),
  isActive: z.boolean(),
  messages: z.array(ChatMessageSchema).default([]),
  systemPrompt: z.string().optional(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  createdBy: zUserId,
  updatedBy: zUserId
});
var SpaceReviewSchema = zObject({
  id: zSpaceReviewId,
  spaceId: zSpaceId,
  tenantId: zTenantId,
  userId: zUserId,
  userName: z.string().optional(),
  rating: z.number().int().min(1).max(5),
  comment: z.string().optional(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  createdBy: zUserId,
  updatedBy: zUserId
});
var StoreSpaceListingSchema = zObject({
  id: zSpaceId,
  sourceTenantId: zTenantId,
  title: z.string(),
  price: zMoney,
  accessType: zSpaceAccessType,
  storeDescription: z.string().optional(),
  storeThumbnailUrl: z.string().optional(),
  ratingAggregate: SpaceRatingAggregateSchema.optional()
});
var SpacePurchaseRecordSchema = zObject({
  id: zPurchaseId,
  userId: zUserId,
  spaceId: zSpaceId,
  sourceTenantId: zTenantId,
  amount: zMoney,
  transactionId: z.string(),
  gateway: z.string(),
  status: zPurchaseStatus,
  purchasedAt: zTimestamp
});
var QuestionProgressDataSchema = zObject({
  status: zQuestionProgressStatus,
  attemptsCount: z.number().int().default(0),
  bestScore: z.number().optional(),
  pointsEarned: z.number().optional(),
  totalPoints: z.number().optional(),
  percentage: z.number().optional(),
  solved: z.boolean().default(false),
  latestScore: z.number().optional(),
  latestStatus: zQuestionProgressStatus.optional()
});
var AttemptRecordSchema = zObject({
  attemptNumber: z.number().int(),
  answer: z.unknown(),
  evaluation: StoredEvaluationSchema,
  score: z.number(),
  maxScore: z.number(),
  timestamp: zTimestamp
});
var ItemProgressEntrySchema = zObject({
  itemId: zItemId,
  itemType: zItemType,
  completed: z.boolean().default(false),
  completedAt: zTimestamp.nullable(),
  timeSpent: z.number().optional(),
  interactions: z.number().int().optional(),
  lastUpdatedAt: zTimestamp,
  // question-specific
  questionData: QuestionProgressDataSchema.optional(),
  // material-specific
  progress: z.number().optional(),
  score: z.number().optional(),
  feedback: z.string().optional(),
  // revisit display
  lastAnswer: z.unknown().optional(),
  lastEvaluation: StoredEvaluationSchema.optional(),
  attempts: z.array(AttemptRecordSchema).optional()
});
var StoryPointProgressSchema = zObject({
  storyPointId: zStoryPointId,
  status: zProgressStatus,
  pointsEarned: z.number().default(0),
  totalPoints: z.number().default(0),
  percentage: z.number().default(0),
  completedItems: z.number().int().default(0),
  totalItems: z.number().int().default(0),
  completedAt: zTimestamp.nullable()
});
var StoryPointProgressDocSchema = zObject({
  storyPointId: zStoryPointId,
  status: zProgressStatus,
  pointsEarned: z.number().default(0),
  totalPoints: z.number().default(0),
  percentage: z.number().default(0),
  completedItems: z.number().int().default(0),
  totalItems: z.number().int().default(0),
  completedAt: zTimestamp.nullable(),
  updatedAt: zTimestamp,
  items: z.record(z.string(), ItemProgressEntrySchema).default({})
});
var SpaceProgressSchema = zObject({
  id: zSpaceProgressId,
  userId: zUserId,
  tenantId: zTenantId,
  spaceId: zSpaceId,
  status: zProgressStatus,
  pointsEarned: z.number().default(0),
  totalPoints: z.number().default(0),
  marksEarned: z.number().optional(),
  totalMarks: z.number().optional(),
  percentage: z.number().default(0),
  storyPoints: z.record(z.string(), StoryPointProgressSchema).default({}),
  startedAt: zTimestamp.nullable(),
  completedAt: zTimestamp.nullable(),
  updatedAt: zTimestamp
});
var RecomputeMarkerSchema = zObject({
  reason: z.enum(["autograde", "levelup", "storyPoint", "atRisk", "manual"]),
  requestedAt: zTimestamp,
  taskId: z.string().optional()
});
var RecentExamEntrySchema = zObject({
  examId: z.string(),
  examTitle: z.string(),
  score: z.number(),
  percentage: z.number(),
  date: zTimestamp
});
var RecentActivityEntrySchema = zObject({
  spaceId: z.string(),
  spaceTitle: z.string(),
  pointsEarned: z.number(),
  date: zTimestamp
});
var AutogradeSubjectBreakdownSchema = zObject({
  avgScore: z.number(),
  examCount: z.number().int()
});
var StudentAutogradeMetricsSchema = zObject({
  totalExams: z.number().int(),
  completedExams: z.number().int(),
  averageScore: z.number(),
  averagePercentage: z.number(),
  totalMarksObtained: z.number(),
  totalMarksAvailable: z.number(),
  subjectBreakdown: z.record(z.string(), AutogradeSubjectBreakdownSchema),
  recentExams: z.array(RecentExamEntrySchema)
});
var StudentLevelupMetricsSchema = zObject({
  totalSpaces: z.number().int(),
  completedSpaces: z.number().int(),
  averageCompletion: z.number(),
  totalPointsEarned: z.number(),
  totalPointsAvailable: z.number(),
  averageAccuracy: z.number(),
  streakDays: z.number().int(),
  subjectBreakdown: z.record(z.string(), z.number()),
  recentActivity: z.array(RecentActivityEntrySchema)
});
var StudentProgressSummarySchema = zObject({
  id: zStudentId,
  tenantId: zTenantId,
  studentId: zStudentId,
  autograde: StudentAutogradeMetricsSchema,
  levelup: StudentLevelupMetricsSchema,
  overallScore: z.number(),
  strengthAreas: z.array(z.string()).default([]),
  weaknessAreas: z.array(z.string()).default([]),
  isAtRisk: z.boolean(),
  atRiskReasons: z.array(zAtRiskReason).default([]),
  lastUpdatedAt: zTimestamp,
  recompute: RecomputeMarkerSchema.optional()
});
var ClassAutogradeMetricsSchema = zObject({
  averageScore: z.number(),
  averagePercentage: z.number(),
  examCount: z.number().int(),
  passRate: z.number()
});
var ClassLevelupMetricsSchema = zObject({
  averageCompletion: z.number(),
  totalPointsEarned: z.number(),
  activeStudents: z.number().int()
});
var ClassProgressSummarySchema = zObject({
  id: zClassId,
  tenantId: zTenantId,
  classId: zClassId,
  className: z.string(),
  studentCount: z.number().int(),
  autograde: ClassAutogradeMetricsSchema,
  levelup: ClassLevelupMetricsSchema,
  atRiskStudentIds: z.array(zStudentId).default([]),
  atRiskCount: z.number().int(),
  lastUpdatedAt: zTimestamp
});
var LearningInsightSchema = zObject({
  id: zInsightId,
  tenantId: zTenantId,
  studentId: zStudentId,
  type: zInsightType,
  priority: zInsightPriority,
  title: z.string(),
  description: z.string(),
  actionType: zInsightActionType,
  actionEntityId: z.string().optional(),
  actionEntityTitle: z.string().optional(),
  createdAt: zTimestamp,
  dismissedAt: zTimestamp.nullable()
});
var ExamQuestionPaperSchema = zObject({
  images: z.array(z.string()),
  extractedAt: zTimestamp.nullable(),
  /** Set when Pass-2 rubric generation completes (live extraction pipeline). */
  rubricsGeneratedAt: zTimestamp.optional(),
  questionCount: z.number().int(),
  examType: z.literal("standard")
});
var ExamGradingConfigSchema = zObject({
  autoGrade: z.boolean(),
  allowRubricEdit: z.boolean(),
  /**
   * @deprecated Read-only legacy field. The canonical location is `Exam.evaluationSettingsId`
   * (top-level). Readers must resolve `exam.evaluationSettingsId ?? exam.gradingConfig?.evaluationSettingsId`.
   * NEVER write here from new code — only the top-level field is written. Retained so existing
   * legacy docs still parse.
   */
  evaluationSettingsId: zEvaluationSettingsId.optional(),
  allowManualOverride: z.boolean(),
  requireOverrideReason: z.boolean(),
  releaseResultsAutomatically: z.boolean()
});
var ExamStatsSchema = zObject({
  totalSubmissions: z.number().int().default(0),
  gradedSubmissions: z.number().int().default(0),
  avgScore: z.number().default(0),
  passRate: z.number().default(0)
});
var ExamSchema = zObject({
  id: zExamId,
  tenantId: zTenantId,
  title: z.string(),
  subject: z.string(),
  topics: z.array(z.string()).default([]),
  classIds: z.array(zClassId).default([]),
  sectionIds: z.array(zSectionId).optional(),
  examDate: zTimestamp,
  duration: z.number().int(),
  academicSessionId: zAcademicSessionId.optional(),
  totalMarks: z.number(),
  passingMarks: z.number(),
  status: zExamStatus,
  questionPaper: ExamQuestionPaperSchema.optional(),
  gradingConfig: ExamGradingConfigSchema,
  evaluationSettingsId: zEvaluationSettingsId.optional(),
  linkedSpaceId: zSpaceId.optional(),
  linkedSpaceTitle: z.string().optional(),
  linkedStoryPointId: zStoryPointId.optional(),
  stats: ExamStatsSchema.optional(),
  createdBy: zUserId,
  createdAt: zTimestamp,
  updatedAt: zTimestamp
});
var SubQuestionSchema = zObject({
  label: z.string(),
  text: z.string(),
  maxMarks: z.number(),
  rubric: UnifiedRubricSchema.optional()
});
var ExamQuestionSchema = zObject({
  id: zExamQuestionId,
  examId: zExamId,
  text: z.string(),
  imageUrls: z.array(z.string()).optional(),
  maxMarks: z.number(),
  order: z.number().int(),
  rubric: UnifiedRubricSchema,
  questionType: zQuestionType.optional(),
  subQuestions: z.array(SubQuestionSchema).optional(),
  linkedItemId: zItemId.optional(),
  extractedBy: zUserId.optional(),
  extractedAt: zTimestamp.nullable(),
  extractionConfidence: z.number().optional(),
  readabilityIssue: z.boolean().optional(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp
});
var AnswerSheetDataSchema = zObject({
  images: z.array(z.string()),
  uploadedAt: zTimestamp,
  uploadedBy: zUserId,
  uploadSource: zUploadSource
});
var ScoutingResultSchema = zObject({
  routingMap: z.record(z.string(), z.array(z.number().int())),
  confidence: z.record(z.string(), z.number()),
  completedAt: zTimestamp
});
var SubmissionSummarySchema = zObject({
  totalScore: z.number(),
  maxScore: z.number(),
  percentage: z.number(),
  grade: zGradeLetter,
  questionsGraded: z.number().int(),
  totalQuestions: z.number().int(),
  completedAt: zTimestamp.nullable()
});
var GradingProgressSchema = zObject({
  graded: z.number().int(),
  total: z.number().int(),
  batchIndex: z.number().int().optional()
});
var SubmissionSchema = zObject({
  id: zSubmissionId,
  examId: zExamId,
  studentId: zStudentId,
  studentName: z.string(),
  rollNumber: z.string(),
  classId: zClassId,
  answerSheets: AnswerSheetDataSchema,
  scoutingResult: ScoutingResultSchema.optional(),
  summary: SubmissionSummarySchema,
  pipelineStatus: zSubmissionPipelineStatus,
  pipelineError: z.string().optional(),
  retryCount: z.number().int().default(0),
  watchdogRetryCount: z.number().int().optional(),
  gradingProgress: GradingProgressSchema.optional(),
  resultsReleased: z.boolean().default(false),
  resultsReleasedAt: zTimestamp.nullable(),
  resultsReleasedBy: zUserId.optional(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp
});
var QuestionMappingSchema = zObject({
  pageIndices: z.array(z.number().int()),
  imageUrls: z.array(z.string()),
  scoutedAt: zTimestamp
});
var ManualOverrideSchema = zObject({
  score: z.number(),
  reason: z.string(),
  overriddenBy: zUserId,
  overriddenAt: zTimestamp,
  originalScore: z.number()
});
var QuestionSubmissionSchema = zObject({
  id: zQuestionSubmissionId,
  submissionId: zSubmissionId,
  questionId: zExamQuestionId,
  examId: zExamId,
  mapping: QuestionMappingSchema,
  evaluation: UnifiedEvaluationResultSchema.optional(),
  gradingStatus: zQuestionGradingStatus,
  gradingError: z.string().optional(),
  gradingRetryCount: z.number().int().default(0),
  manualOverride: ManualOverrideSchema.optional(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp
});
var QuestionAnalyticsEntrySchema = zObject({
  questionId: zExamQuestionId,
  avgScore: z.number(),
  maxScore: z.number(),
  attemptCount: z.number().int(),
  difficultyIndex: z.number().optional(),
  discriminationIndex: z.number().optional()
});
var ClassBreakdownEntrySchema = zObject({
  classId: zClassId,
  avgScore: z.number(),
  avgPercentage: z.number(),
  submissionCount: z.number().int()
});
var TopicPerformanceEntrySchema = zObject({
  topic: z.string(),
  avgPercentage: z.number(),
  questionCount: z.number().int()
});
var ScoreDistributionSchema = zObject({
  buckets: z.array(z.object({ label: z.string(), count: z.number().int() }).strict()),
  gradeDistribution: z.record(z.string(), z.number().int()).optional()
});
var ExamAnalyticsSchema = zObject({
  id: zExamAnalyticsId,
  tenantId: zTenantId,
  examId: zExamId,
  totalSubmissions: z.number().int(),
  gradedSubmissions: z.number().int(),
  avgScore: z.number(),
  avgPercentage: z.number(),
  passRate: z.number(),
  medianScore: z.number(),
  scoreDistribution: ScoreDistributionSchema,
  questionAnalytics: z.record(z.string(), QuestionAnalyticsEntrySchema),
  classBreakdown: z.record(z.string(), ClassBreakdownEntrySchema),
  topicPerformance: z.record(z.string(), TopicPerformanceEntrySchema),
  computedAt: zTimestamp,
  lastUpdatedAt: zTimestamp
});
var CostBucketSchema = zObject({
  calls: z.number().int(),
  inputTokens: z.number().int(),
  outputTokens: z.number().int(),
  costUsd: z.number()
});
var costSummaryShape = {
  totalCalls: z.number().int(),
  totalInputTokens: z.number().int(),
  totalOutputTokens: z.number().int(),
  totalCostUsd: z.number(),
  byPurpose: z.record(z.string(), CostBucketSchema),
  byModel: z.record(z.string(), CostBucketSchema),
  budgetLimitUsd: z.number().optional(),
  budgetUsedPercent: z.number().optional(),
  budgetAlertSent: z.boolean().optional(),
  computedAt: zTimestamp
};
var DailyCostSummarySchema = zObject({
  id: zCostSummaryId,
  tenantId: zTenantId,
  date: zIsoDate,
  ...costSummaryShape
});
var MonthlyCostSummarySchema = zObject({
  id: zCostSummaryId,
  tenantId: zTenantId,
  // YYYY-MM
  month: z.string().regex(/^\d{4}-\d{2}$/),
  ...costSummaryShape
});
var LlmCallLogSchema = zObject({
  id: zLlmCallLogId,
  tenantId: zTenantId,
  functionName: z.string(),
  model: z.string(),
  inputTokens: z.number().int(),
  outputTokens: z.number().int(),
  totalTokens: z.number().int(),
  costUSD: z.number(),
  latencyMs: z.number().int(),
  status: zLlmCallStatus,
  errorMessage: z.string().optional(),
  userId: zUserId.optional(),
  examId: zExamId.optional(),
  spaceId: zSpaceId.optional(),
  createdAt: zTimestamp
});
var HealthSnapshotSchema = zObject({
  id: zHealthSnapshotId,
  date: zIsoDate,
  status: zDayHealthStatus,
  services: z.record(
    z.string(),
    z.object({ status: zDayHealthStatus, latencyMs: z.number().optional() }).strict()
  ),
  checkedAt: zTimestamp
});
var PlatformActivityLogSchema = zObject({
  id: zPlatformActivityLogId,
  action: zPlatformActivityAction,
  actorUid: zUserId,
  actorEmail: z.string(),
  tenantId: zTenantId.optional(),
  metadata: z.record(z.string(), z.unknown()),
  createdAt: zTimestamp
});
var AchievementCriteriaSchema = zObject({
  type: zAchievementCriteriaType,
  threshold: z.number().int().min(1),
  subject: z.string().optional(),
  spaceId: zSpaceId.optional()
});
var AchievementSchema = zObject({
  id: zAchievementId,
  tenantId: zTenantId,
  title: z.string(),
  description: z.string(),
  icon: z.string(),
  category: zAchievementCategory,
  rarity: zAchievementRarity,
  tier: zAchievementTier,
  criteria: AchievementCriteriaSchema,
  pointsReward: z.number().int().min(0),
  isActive: z.boolean(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  archivedAt: zTimestamp.nullable()
});
var StudentAchievementSchema = zObject({
  id: zStudentAchievementId,
  tenantId: zTenantId,
  userId: zUserId,
  achievementId: zAchievementId,
  // denormalized snapshot for display (server writes at unlock).
  achievement: AchievementSchema,
  earnedAt: zTimestamp,
  // the ONLY client-mutable field (mark-read).
  seen: z.boolean()
});
var StudentLevelSchema = zObject({
  id: zUserId,
  tenantId: zTenantId,
  userId: zUserId,
  level: z.number().int().min(1),
  currentXP: z.number().int().min(0),
  xpToNextLevel: z.number().int().min(0),
  totalXP: z.number().int().min(0),
  tier: zAchievementTier,
  achievementCount: z.number().int().min(0),
  updatedAt: zTimestamp
});
var StudyGoalSchema = zObject({
  id: zStudyGoalId,
  tenantId: zTenantId,
  userId: zUserId,
  title: z.string(),
  description: z.string().optional(),
  targetType: zStudyGoalTargetType,
  targetCount: z.number().int().min(1),
  // server-derived
  currentCount: z.number().int().min(0),
  startDate: zIsoDate,
  endDate: zIsoDate,
  completed: z.boolean(),
  completedAt: zTimestamp.nullable(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp,
  archivedAt: zTimestamp.nullable()
});
var StudySessionSchema = zObject({
  id: zStudySessionId,
  tenantId: zTenantId,
  userId: zUserId,
  date: zIsoDate,
  minutesStudied: z.number().int().min(0),
  spacesWorked: z.array(zSpaceId).default([]),
  itemsCompleted: z.number().int().min(0),
  pointsEarned: z.number().int().min(0)
});
var LeaderboardEntrySchema = zObject({
  userId: zUserId,
  displayName: z.string(),
  avatarUrl: z.string().optional(),
  score: z.number(),
  overallScore: z.number().optional(),
  examAvg: z.number().optional(),
  spaceCompletion: z.number().optional(),
  totalPoints: z.number(),
  streakDays: z.number().int(),
  tier: zAchievementTier.optional(),
  countsByTier: z.record(z.string(), z.number().int()).optional(),
  rank: z.number().int(),
  isAtRisk: z.boolean().optional(),
  updatedAt: zTimestamp
});
var GamificationSummarySchema = zObject({
  level: StudentLevelSchema,
  recentAchievements: z.array(StudentAchievementSchema),
  unseenCount: z.number().int().min(0),
  currentStreakDays: z.number().int().min(0),
  tenantRank: z.number().int().nullable(),
  activeGoals: z.array(StudyGoalSchema)
});
var NotificationSchema = zObject({
  id: zNotificationId,
  tenantId: zTenantId,
  recipientUid: zUserId,
  recipientRole: zNotificationRecipientRole,
  type: zNotificationType,
  title: z.string().max(200),
  body: z.string().max(1e3),
  entityType: zNotificationEntityType.optional(),
  entityId: z.string().optional(),
  actionUrl: z.string().optional(),
  isRead: z.boolean().default(false),
  createdAt: zTimestamp,
  readAt: zTimestamp.nullable()
});
var NotificationPreferencesSchema = zObject({
  id: z.string(),
  tenantId: zTenantId,
  userId: zUserId,
  enabledTypes: z.array(zNotificationType).default([]),
  muteUntil: zTimestamp.nullable()
});
var NotificationBadgeStateSchema = zObject({
  unreadCount: z.number().int().min(0),
  latest: zObject({
    id: zNotificationId,
    title: z.string(),
    type: zNotificationType,
    createdAt: z.number().int()
  }).optional()
});
var AnnouncementSchema = zObject({
  id: zAnnouncementId,
  tenantId: zTenantId.nullable(),
  title: z.string().max(200),
  body: z.string().max(5e3),
  authorUid: zUserId,
  authorName: z.string(),
  scope: zAnnouncementScope,
  targetRoles: z.array(zNotificationRecipientRole).max(10).optional(),
  targetClassIds: z.array(zClassId).max(100).optional(),
  status: zAnnouncementStatus,
  publishedAt: zTimestamp.nullable(),
  archivedAt: zTimestamp.nullable(),
  expiresAt: zTimestamp.nullable(),
  createdAt: zTimestamp,
  updatedAt: zTimestamp
});

export { ACHIEVEMENT_CATEGORIES, ACHIEVEMENT_CRITERIA_TYPES, ACHIEVEMENT_RARITIES, ACHIEVEMENT_TIERS, AGENT_TYPES, AI_EVALUATABLE_TYPES, ALLOWED_TRANSITIONS, ANNOUNCEMENT_SCOPES, ANNOUNCEMENT_STATUSES, ANNOUNCEMENT_TRANSITIONS, AT_RISK_REASONS, AUTHORING_DIFFICULTIES, AUTH_PROVIDERS, AUTO_EVALUATABLE_TYPES, AcademicSessionSchema, AchievementCriteriaSchema, AchievementSchema, AdaptiveConfigSchema, AdaptiveStateSchema, AgentAssessmentAnswerKeyDataSchema, AgentAssessmentContextSchema, AgentAssessmentLearnerAnswerSchema, AgentAssessmentPrivateObjectiveSchema, AgentAssessmentQuestionPromptSchema, AgentSchema, AnalyticsBreakdownEntrySchema, AnnouncementSchema, AnswerKeySchema, AnswerSheetDataSchema, AssessmentConfigSchema, AssessmentScheduleSchema, AttemptRecordSchema, AutogradeSubjectBreakdownSchema, BLOOMS_LEVELS, BRAND_TAGS, CHAT_MESSAGE_ROLES, CONSUMER_PLANS, CONTENT_CHANGE_TYPES, CONTENT_VERSION_ENTITY_TYPES, CONVERSATION_MODES, CONVERSATION_SESSION_STATUSES, CONVERSATION_TOOL_NAMES, CONVERSATION_TURN_STATUSES, COST_SUMMARY_GRANULARITIES, CREDENTIAL_OWNERS, CURRENCIES, ChatMessageSchema, ChatSessionSchema, ClassAutogradeMetricsSchema, ClassBreakdownEntrySchema, ClassLevelupMetricsSchema, ClassProgressSummarySchema, ClassSchema, ConsumerProfileSchema, ContentVersionSchema, ConversationAgentSchema, ConversationBumpSchema, ConversationCompletionPolicySchema, ConversationCompletionRecommendationSchema, ConversationConfigurationSnapshotSchema, ConversationContentBlockSchema, ConversationContextSchema, ConversationErrorSchema, ConversationEvidenceDocSchema, ConversationFinalizationSchema, ConversationGradingViewSchema, ConversationLastMessagePreviewSchema, ConversationLeaseSchema, ConversationMessageSchema, ConversationMessageViewSchema, ConversationPublicConfigSchema, ConversationPublicLearningObjectiveSchema, ConversationPublicSourceVersionSchema, ConversationSafeResultSchema, ConversationSessionDocSchema, ConversationSessionKeyDocSchema, ConversationSessionSummaryViewSchema, ConversationSessionViewSchema, ConversationToolInvocationSchema, ConversationTurnDocSchema, ConversationTurnSchema, ConversationTurnViewSchema, CostBucketSchema, DAY_HEALTH_STATUSES, DEAD_LETTER_RESOLUTION_METHODS, DEFAULT_PAGE_LIMIT, DIFFICULTIES, DIMENSION_PRIORITIES, DISCUSSION_THREAD_TYPES, DailyCostSummarySchema, DifficultyProgressionEntrySchema, DigitalTestSessionSchema, ENTITY_STATUSES, ENTITY_STATUS_TRANSITIONS, EXAM_STATUSES, EXAM_TRANSITIONS, EvaluationConfidenceConfigSchema, EvaluationDimensionSchema, EvaluationDisplaySettingsSchema, EvaluationSettingsSchema, EvaluationSummarySchema, ExamAnalyticsSchema, ExamGradingConfigSchema, ExamQuestionPaperSchema, ExamQuestionSchema, ExamSchema, ExamStatsSchema, FEEDBACK_SEVERITIES, FeedbackItemSchema, GRADE_LETTERS, GRADE_THRESHOLDS, GRADING_PIPELINE_STEPS, GamificationSummarySchema, GradingDeadLetterEntrySchema, GradingProgressSchema, HealthSnapshotSchema, ID_ROLES, INSIGHT_ACTION_TYPES, INSIGHT_PRIORITIES, INSIGHT_TYPES, INTERACTIVE_TYPES, ISO_8601_UTC, ISO_DATE, ITEM_ASSESSMENT_TYPES, ITEM_ATTACHMENT_TYPES, ITEM_KINDS, ITEM_TYPES, InvalidTransitionError, ItemAnalyticsSchema, ItemAttachmentSchema, ItemMetadataSchema, ItemPayloadSchema, ItemProgressEntrySchema, ItemSubmissionDocSchema, ItemSubmissionEvaluationAttemptDocSchema, ItemSubmissionEvaluationSchema, ItemSubmissionPayloadSchema, ItemSubmissionViewSchema, ItemSubmissionWorkflowSchema, JOIN_SOURCES, KEY_PROVIDERS, KEY_STATUSES, LEADERBOARD_SCOPES, LEGACY_EXAM_STATUSES, LEGACY_GRADING_PIPELINE_STEPS, LEGACY_STORY_POINT_TYPES, LEGACY_SUBMISSION_PIPELINE_STATUSES, LEGACY_TEST_SESSION_TYPES, LEGACY_UPLOAD_SOURCES, LLM_CALL_STATUSES, LeaderboardEntrySchema, LearningInsightSchema, LegacyAgentReadSchema, LlmCallLogSchema, MATERIAL_TYPES, MAX_CLAIM_CLASS_IDS, MAX_PAGE_LIMIT, MEMBERSHIP_STATUSES, MEMBERSHIP_TRANSITIONS, MISTAKE_CLASSIFICATIONS, MODEL_POLICY_IDS, ManualOverrideSchema, McqOptionSchema, MoneySchema, MonthlyCostSummarySchema, NOTIFICATION_ENTITY_TYPES, NOTIFICATION_RECIPIENT_ROLES, NOTIFICATION_TYPES, NotificationBadgeStateSchema, NotificationPreferencesSchema, NotificationSchema, OwnedKeyStatusSchema, PLATFORM_ACTIVITY_ACTIONS, PROGRESS_STATUSES, PURCHASE_STATUSES, ParentSchema, PlatformActivityLogSchema, PlatformClaimsSchema, ProgressApplicationDocSchema, PurchaseRecordSchema, PyqInfoSchema, QUESTION_GRADING_STATUSES, QUESTION_GRADING_TRANSITIONS, QUESTION_PROGRESS_STATUSES, QUESTION_STATUSES, QUESTION_TYPES, QUESTION_TYPE_REGISTRY, QuestionAnalyticsEntrySchema, QuestionBankItemSchema, QuestionHelpContextSchema, QuestionMappingSchema, QuestionProgressDataSchema, QuestionSubmissionSchema, QuestionTypeDataSchema, RICH_BLOCK_TYPES, ROLE_DESCRIPTORS, ROLE_RANK, RUBRIC_PRESET_CATEGORIES, RUBRIC_SCORING_MODES, RecentActivityEntrySchema, RecentExamEntrySchema, RecomputeMarkerSchema, RetryConfigSchema, RubricBreakdownItemSchema, RubricCriterionLevelSchema, RubricCriterionSchema, RubricPresetSchema, SPACE_ACCESS_TYPES, SPACE_STATUSES, SPACE_TRANSITIONS, SPACE_TYPES, STAFF_PERMISSION_KEYS, STORY_POINT_TYPES, STUDY_GOAL_TARGET_TYPES, SUBMISSION_PIPELINE_STATUSES, SUBMISSION_TRANSITIONS, SUBMISSION_WORKFLOW_STATUSES, ScannerSchema, ScoreDistributionSchema, ScoutingResultSchema, SpaceProgressSchema, SpacePurchaseRecordSchema, SpaceRatingAggregateSchema, SpaceReviewSchema, SpaceSchema, SpaceStatsSchema, StaffSchema, StartConversationContextSchema, StoreSpaceListingSchema, StoredEvaluationSchema, StoredEvaluationSummarySchema, StoryPointProgressDocSchema, StoryPointProgressSchema, StoryPointSchema, StoryPointSectionSchema, StoryPointStatsSchema, StudentAchievementSchema, StudentAutogradeMetricsSchema, StudentLevelSchema, StudentLevelupMetricsSchema, StudentProgressSummarySchema, StudentSchema, StudyGoalSchema, StudySessionSchema, SubQuestionSchema, SubmissionSchema, SubmissionSummarySchema, TEACHER_PERMISSION_KEYS, TENANT_PLANS, TENANT_ROLES, TENANT_STATUSES, TENANT_TRANSITIONS, TEST_SESSION_STATUSES, TEST_SESSION_TRANSITIONS, TEST_SESSION_TYPES, TeacherPermissionsSchema, TeacherSchema, TenantBrandingSchema, TenantCodeIndexSchema, TenantDeactivationSchema, TenantFeaturesSchema, TenantOnboardingSchema, TenantPublicViewSchema, TenantSchema, TenantSettingsSchema, TenantStatsSchema, TenantSubscriptionSchema, TenantUsageSchema, TestAnalyticsSchema, TestSubmissionSchema, TopicPerformanceEntrySchema, TutorContextSchema, TutorItemContextSchema, TutorSpaceContextSchema, TutorStoryPointContextSchema, UPLOAD_SOURCES, USER_STATUSES, UnifiedEvaluationResultSchema, UnifiedItemSchema, UnifiedRubricSchema, UnifiedUserSchema, UsageQuotaConfigSchema, UserMembershipSchema, UserPreferencesSchema, UserProviderKeySchema, UserProviderKeyViewSchema, addMoney, asAcademicSessionId, asAchievementId, asAgentId, asAnnouncementId, asAnswerKeyId, asChatMessageId, asChatSessionId, asClassId, asContentVersionId, asConversationEvidenceId, asConversationMessageId, asConversationSessionId, asConversationTurnId, asCostSummaryId, asCursor, asDeadLetterEntryId, asEvaluationSettingsId, asExamAnalyticsId, asExamId, asExamQuestionId, asHealthSnapshotId, asInsightId, asIsoDate, asItemId, asItemSubmissionId, asLlmCallLogId, asMembershipId, asModuleId, asNotificationId, asParentId, asPlatformActivityLogId, asPurchaseId, asQuestionBankItemId, asQuestionSubmissionId, asRubricPresetId, asScannerId, asSectionId, asSessionId, asSpaceId, asSpaceProgressId, asSpaceReviewId, asStaffId, asStoryPointId, asStudentAchievementId, asStudentId, asStudentLevelId, asStudyGoalId, asStudySessionId, asSubmissionId, asTeacherId, asTenantCode, asTenantId, asTestSessionId, asTimestamp, asUserId, assertTransition, canTransition, coerceUnifiedRubric, evaluateTenantAccess, formatMoney, gradeForPercentage, idFieldForRole, isAuthoringRole, isIsoDate, isTimestamp, isoNow, maskKey, minimalQuestionData, money, normalizeExamStatus, normalizeGradeLetter, normalizeGradingPipelineStep, normalizeStoryPointType, normalizeSubmissionPipelineStatus, normalizeTestSessionType, normalizeUploadSource, repoKeyForRole, roleIdFields, systemClock, toDateObj, toMillis, toTimestamp, userProviderKeyId, withAudit, zAcademicSessionId, zAchievementCategory, zAchievementCriteriaType, zAchievementId, zAchievementRarity, zAchievementTier, zAgentId, zAgentType, zAnnouncementId, zAnnouncementScope, zAnnouncementStatus, zAnswerKeyId, zAtRiskReason, zAuditFields, zAuthProvider, zAuthoringDifficulty, zBloomsLevel, zBrandedId, zChatMessageId, zChatMessageRole, zChatSessionId, zClassId, zConsumerPlan, zContentChangeType, zContentVersionEntityType, zContentVersionId, zConversationEvidenceId, zConversationMessageId, zConversationMode, zConversationSessionId, zConversationSessionStatus, zConversationToolName, zConversationTurnId, zConversationTurnStatus, zCostSummaryGranularity, zCostSummaryId, zCredentialOwner, zCurrency, zCursor, zDayHealthStatus, zDeadLetterEntryId, zDifficulty, zDimensionPriority, zDiscussionThreadType, zEntityStatus, zEnum, zEvaluationSettingsId, zExamAnalyticsId, zExamId, zExamQuestionId, zExamStatus, zFeedbackSeverity, zGradeLetter, zHealthSnapshotId, zInsightActionType, zInsightId, zInsightPriority, zInsightType, zInteractiveType, zIsoDate, zItemAssessmentType, zItemAttachmentType, zItemId, zItemSubmissionId, zItemType, zJoinSource, zJsonObject, zJsonValue, zKeyProvider, zKeyStatus, zLeaderboardScope, zLegacyExamStatusRead, zLegacyGradeLetterRead, zLegacyGradingPipelineStepRead, zLegacyStoryPointTypeRead, zLegacySubmissionPipelineStatusRead, zLegacyTestSessionTypeRead, zLegacyUploadSourceRead, zLlmCallLogId, zLlmCallStatus, zMaterialType, zMembershipId, zMembershipStatus, zMistakeClassification, zModelPolicyId, zMoney, zNotificationEntityType, zNotificationId, zNotificationRecipientRole, zNotificationType, zObject, zPage, zPageParams, zParentId, zPlatformActivityAction, zPlatformActivityLogId, zProgressStatus, zPurchaseId, zPurchaseStatus, zQuestionBankItemId, zQuestionGradingStatus, zQuestionProgressStatus, zQuestionStatus, zQuestionSubmissionId, zQuestionType, zRichBlockType, zRubricPresetCategory, zRubricPresetId, zRubricScoringMode, zScannerId, zSectionId, zSessionId, zSoftDeletable, zSpaceAccessType, zSpaceId, zSpaceProgressId, zSpaceReviewId, zSpaceStatus, zSpaceType, zStaffId, zStaffPermissionKey, zStoryPointId, zStoryPointType, zStudentAchievementId, zStudentId, zStudentLevelId, zStudyGoalId, zStudyGoalTargetType, zStudySessionId, zSubmissionId, zSubmissionPipelineStatus, zSubmissionWorkflowStatus, zTeacherId, zTeacherPermissionKey, zTenantCode, zTenantId, zTenantPlan, zTenantRole, zTenantScoped, zTenantStatus, zTestSessionId, zTestSessionStatus, zTestSessionType, zTimestamp, zTimestampInput, zUploadSource, zUserId, zUserStatus };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map